module.exports = {
  message: {
    hello: '您好 ',
    switchLanguage: '切换语言',
    switchSystem: '切换系统',
    logout: '退出',
    restore: '还原',
    theme: '主题',
    uploadFile: "单击或拖动文件到此处上传",
    uploadTemplate: "上传模板",
    selectTemplate: "选择模板",
    templateName: "模板名称",
    import: "导入",
    ActiveorNot:'是否激活',
    ExpiryDate:'有效截止日期',
    Expiry:'激活',
    close:'关闭',
    ActivationCode:'激活码',
    getActivationCode:'获取激活码',
    ActivationType:'激活时长',
    select:'查询',
    tips:'根据AWS建议的最佳实践，不推荐使用AKSK的账户访问方式，推荐使用AssumeRole的访问方式。',
    noPermission: '暂无权限，请联系管理员',
    managementSystem: '管理系统',
    copySuccessfully: '复制成功',
    copyFailed: '复制失败'
  },
  // 账单数据
  BillingServices:{
    BillingRules:'账单规则',
    Dataprocessingrules:'数据处理规则',
    Pleaseselectacompany:'请选择公司',
    Querybyrulename:'请输入规则名称',
    select:'查询',
    AddRule:'添加规则',
    companyName:'公司名称',
    ruleName:'规则名称',
    Cloudplatformtype:'云平台类型',
    Billingdatasource:'账单数据源 ',
    Appliedlabelrules:'应用的标签规则',
    oper:'操作',
    del:'删除',
    Operationlog:'操作日志',
    AddProcessingRule:'添加处理规则',
    company:'公司',
    WhetherRIprocessingisrequired:'是否需要RI处理',
    LabelRules:'标签规则',
    cancel:'取消',
    add:'添加',
    edit: "编辑",
    EditProcessingRule:'编辑处理规则',
    confirm:'确认',
    Operationmodule:'操作模块',
    Operationfield:'操作字段',
    Originalvalue:'原值',
    Newvalue:'新值',
    Operator:'操作人',
    UpdateTime:'更新时间',
    Labelhandlingrules:'标签处理规则',
    conditionsforexecution:'执行条件',
    Conditioncontent:'条件内容',
    Executeaction:'执行动作',
    Satisfyanyone :'满足任意一个',
    Meetall:'满足所有',
    PleaseentertagKey:'请输入tagKey',
    PleaseentertagValue:'请输入tagValue',
    AddLabel:'添加标签',

    // 新加
    AddLabelRule:'添加标签规则',
    editLabelRule:'编辑标签规则',

    // 导出
    BillExport:'AWS账单导出',
    ExportAWSbill:'导出AWS账单',
    ExportRecords:'导出记录',
    ExportTemplate:'导出模板',
    Querybyrecordname:'请输入记录名称',
    QuerybyTemplateName:'请输入模板名称',
    Pleaseselecttheexportstatus:'请选择导出状态',
    export:'导出',
    Recordname:'记录名称',
    Accountlists:'账号列表',
    Billingtimerange:'账单时间范围',
    status:'状态',
    TemplateName:'模板名称',
    ExportListFields:'导出列表字段',
    ExportStatisticsFields:'导出统计字段',
    Exporttagfield:'导出tag字段',
    Exporttime:'导出时间',
    download:'下载',
    DownloadRecords:'下载记录',
    ExportRecordName:'导出记录名称',
    ListFields:'列表字段',
    Statisticalields:'统计字段',
    Tagfield:'tag字段',
    Downloader:'下载人',
    Downloadtime:'下载时间',
    addtemplate:'添加模板',
    Cloudplatformtype:'云平台类型',
    Billofaccountcloudplatform:'账单云平台',
    AccountList:'账户列表',
    EditTemplate:'编辑模板', },
  // 仪表盘菜单
  dashboard: {
    dashboard: '仪表盘',
    tickets: '本月案例数量',
    ticket: '案例',
    averageResponseTime: '平均响应时间',
    maximumLevel: '最高等级事件数量',
    eventCreation: '事件创建',
    currentBacklog: '当前待办总数',
    hosts: '当前主机数目',
    host: '主机',
    running: '运行',
    stopping: '关机',
    hostCreation: '一周主机创建',
    alarms: '当前监控指标总数',
    securityRating: '安全评分',
    security: '安全',
    totalRisks: '总风险数量',
    highRisks: '高风险等级数量',
    baselineProblems: '基线问题数量',
    holes: '漏洞数量',
    sumCost: '当前账务汇总',
    cost: '花费',
    currentCost: '本月当前费用',
    cumulative: '今年累计花费',
    expected: '本月预计花费',
    recharge: '上次充值金额',
    date: '充值日期',
    balance: '账户余额',
    spendingThan: '支出占比（按标签）',
    backlog: '待办事项',
    subject: '主题',
    classification: '分类',
    serious: '严重',
    updateTime: '更新时间',
    status: '状态',
    resourceCreated: '资源创建数量',
    log: '日志',
    netRejection: '网络访问拒绝',
    resourceDeletion: '资源删除',
    resourceChange: '一周资源更新 ',
    exceptionRequest: '本月异常请求总数',
    estimatedTotal: '本月预计费用',
    noMatchRI: '未匹配RI',
    rISaving: '本月RI节省',
    // 待办事项
    theme: '主题',
    resource: '分类',
    priority: '优先级',
    modifiedTime: '更新时间'
  },
  // 案例菜单
  ticket: {
    // 案例列表
    list: {
      isReply: '是否回复',
      ticket: '案例 ',
      addTicket: '添加案例',
      addComment: '添加评论',
      category: '问题类型',
      subject: '概要',
      status: '状态',
      monitorModule: '监控模块',
      level: '优先级',
      assignee: '经办人',
      attachment: '附件',
      description: '描述',
      cancel: '取消  ',
      confirm: '确定  ',
      ticketEntityID: '案例ID',
      operation: '操作',
      delete: '删除',
      detail: '详情',
      ticketDetail: '案例详情',
      export: '导出',
      return: '返回案例',
      reporter: '报告人',
      date: '日期',
      createdDate: '创建日期',
      modifiedDate: '更新日期',
      comment: '评论',
      addedComments: '添加了评论 ',
      changeRecord: '改动记录 ',
      operator: '操作人 ',
      fieldType: '字段类型 ',
      originalValue: '原值 ',
      newValue: '新值 ',
      modifiedTime: '更新时间',
      attachmentList: '附件列表 ',
      fileName: '文件名',
      storagePath: '存储路径',
      affirmDownload: '下载确认',
      personnel: '人员',
      createdTime: '创建时间',
      handleTime: '处理时间',
      waitTime: '响应时间',
      finishTime: '完成时间',
      Process: '处理',
      selectByCaseId: '请输入案例ID',
      selectByCompany: '请输入公司',
      selectByPriority: '请输入优先级',
      selectByStatus: '请输入状态',
      selectByProblemTypes: '请输入问题类型',
      selectByOperator: '请输入经办人',
      selectByDate: '请输入创建时间',
      closeReason: '关闭理由',
      confirmMan: '确认人',
      editTicket: '编辑案例',
      allocation: '分配',
      keyDistribution: '一键分配',
      enableKeyDistribution: '你确定要使用一键分配吗?',
      Pending: '等待处理',
      Processing: '正在处理',
      Finish: '手动关闭',
      WaitingForTheAuthorization: '等待授权',
      CheckNozzle: '自动完成',
      UnderReview: '审核中',
      TheAuditFails: '审核不通过',
      Approved: '审批通过',
      Confirming: '确认中',
      Confirmed: '已确认',
      updateStatus:'更新状态',
      list:'列表',
      continuePurchase:'是否续买'
    },
    // 评论
    comment: {
      addComments: "添加评论",
      comment: "评论",
      changeRecord: "改动记录",
      attachmentList: "附件列表",
      confirmDownload: "你确定要下载",
      what: "吗",
      download: "下载",
      responsiblePerson: "操作人",
      operationType: "操作类型",
      originValue: "原值",
      newValue: "新值",
      description: "描述",
      updateTime: "更新时间",
      fileName: "文件名称",
      fileType: "文件类型",
      storagePath: "存储路径",
      pleaseEnterDescription: "请输入描述",

    },
    // 案例仪表盘
    dashboard: {
      realTimeStatistics: '案例处理实时统计',
      status: '状态',
      averageResponseTime: '案例处理实时统计',
      responseTime: '响应时间',
      count: '数量'
    }
  },

  // 监控告警管理菜单
  alarms: {
    // 实例
    instance: {
      instance: '实例',
      instanceConfiguration: '实例配置',
      accountType: '账户类型',
      disk: '磁盘 ',
      systemDisk: '系统盘',
      dateDisk: '数据盘',
      hostInformation: '主机信息',
      instanceId: '实例ID',
      addInstanceAlarm: '添加实例报警规则',
      editInstanceAlarm: '编辑实例报警规则',
      instanceName: '实例名称',
      accountName: '账户名称',
      ip: 'IP地址',
      state: '状态',
      region: '区域',
      cpuUsage: 'CPU使用率',
      memoryUsage: '内存使用率',
      diskSpaceUsage: '磁盘空间使用率',
      networkInput: '网络输入',
      networkOutput: '网络输出',
      instanceHealthCheck: '实例健康状态检查',
      systemHealthCheck: '系统健康状态检查',
      instanceMaintenanceInformation: '实例维护信息',
      frequentLoginFailures: '频繁登录失败',
      linuxInodeUsage: 'Linux Inode 使用率',
      instanceList: '实例列表',
      total: '共',
      diskSize: '块磁盘',
      publicIp:"弹性IP",
      allocationId:"分配id",
      privateIp:"私有ip",
      // 折线图
      line:{
        MemoryAvailability:'内存可用量',
        swapUsage:'交换空间大小',
        volumeReadIOPs:'磁盘读IOPS',
        volumeWriteIOPs:'磁盘写IOPS',
        ReadIOPs:'读IOPS',
        WriteIOPs:'写IOPS',
        readLatency:'读取延迟',
        writeLatency:'写入延迟',
        CPUUtilizationPercent:'CPU利用率 (百分比)',
        CPUUtilization:'CPU利用率',
        CPUUtilizationForecast:'CPU利用率预测',
        MemoryUsagePercentage:'内存使用率 (百分比)',
        MemoryUsage:'内存使用率',
        MemoryUsageForecast:'内存使用率预测',
        DiskUtilizationPercent:'磁盘利用率 (百分比)',
        DiskUtilizationPercentForecast:'磁盘利用率预测 (百分比)',
        DiskUtilization:'磁盘利用率',
        LinuxInodeUtilizationPercentage:'Linux Inode 利用率 (百分比)',
        DiskReadAndWriteBytes:'磁盘读写 (字节)',
        DiskRead:'磁盘读',
        DiskWrite:'磁盘写',
        DiskReadForecast:'磁盘读预测',
        DiskWriteForecast:'磁盘写预测',
        ReadAndWriteDiskOperationsOperations:'读写磁盘操作 (操作)',
        DiskReadOperation:'磁盘读操作',
        DiskWriteOperation:'磁盘写操作',
        DiskReadOperationForecast:'磁盘读操作预测',
        DiskWriteOperationForecast:'磁盘写操作预测',
        NetworkInputAndOutputBytes:'网络输入输出 (字节)',
        NetworkInput:'网络输入',
        NetworkOutput:'网络输出',
        NetworkInputForecast:'网络输入预测',
        NetworkOutputForecast:'网络输出预测',
        IncomingAndOutgoingNetworkPacketsNumber:'网络数据包传入传出 (数量)',
        IncomingNetworkPackets:'网络数据包传入',
        OutgoingNetworkPackets:'网络数据包传出',
        IncomingNetworkPacketsForecast:'网络数据包传入预测',
        OutgoingNetworkPacketsForecast:'网络数据包传出预测',
        StatusCheckFailedArbitraryQuantity:'状态检查失败(任意)(数量)',
        StatusCheckFailedOptional:'状态检查失败(任意)',
        StatusCheckFailedInstanceQuantity:'状态检查失败(实例) (数量)',
        StatusCheckFailedExample:'状态检查失败(实例)',
        StatusCheckFailedSystemQuantity:'状态检查失败(系统) (数量)',
        StatusCheckFailedSystem:'状态检查失败(系统)',
        CPUQuotaUsageQuantity:'CPU额度使用 (数量)',
        CPUCreditUsage:'CPU额度使用',
        CPUQuotaBalanceQuantity:'CPU额度余额 (数量)',
        CPUQuotaBalance:'CPU额度余额',
        DiskSpaceUsagePercentage:'磁盘空间使用率（百分比）',
        DiskSpaceUsage:'磁盘空间使用率',
        NetworkIncomingBandwidthBit:'网络流入带宽(bit/s)',
        IncomingInternetBandwidth:'公网流入带宽',
        InboundBandwidthFromPrivateNetwork:'私网流入带宽',
        NetworkOutgoingBandwidthBit:'网络流出带宽(bit/s)',
        PublicNetworkOutgoingBandwidth:'公网流出带宽',
        PrivateNetworkOutgoingBandwidth:'私网流出带宽',
        AverageDiskBPSBps:'磁盘平均BPS (Bps)',
        DiskTotalReadBPS:'磁盘总读BPS',
        DiskTotalWriteBPS:'磁盘总写BPS',
        DiskAverageIOPSTimesSec:'磁盘平均IOPS (次/秒)',
        DiskReadIOPS:'磁盘读IOPS',
        DiskWriteIOPS:'磁盘写IOPS',
        DiskReadIOPSForecast:'磁盘读IOPS预测',
        DiskWriteIOPSForecast:'磁盘写IOPS',
        StandardCpuUsage:"CPU使用率",
        StandardMemoryUsage:"内存使用率",
        StandardConnectionUsage:"连接数使用率",
        StandardQPSUsage:"QPS使用率",
        StandardIntranetRatio:"宽带使用率",
        StandardIntranetInRatio:"流入宽带使用率",
        StandardIntranetOutRatio:"流出带宽使用率",
        VpcPublicIpInternetOutRatePercent:"公网流出带宽使用率(bit/s)",
        TotalCPUCurrentlyPercent:"当前消耗的总CPU(百分比)",
        TotalCPUCurrently:"当前消耗的总CPU",
        NetWorkPackage:"网络流入流出数据包数(pps)(Count/s)",
        NetworkinPackages:"网络流入数据包数",
        NetworkoutPackages:"网络流出数据包数",
        TcpConnection:"TCP连接数(个)",
        ESTABLISHED:"ESTABLISHED",
        NON_ESTABLISHED:"NON_ESTABLISHED",
       TCP_TOTAL:"TCP_TOTAL",
       AverageSystemLoad:"系统平均负载",
       load1m:"load1m",
       load5m:"load5m",
       load15m:"load15m",
       NetworkRate:"网络输入输出",
       NetworkinRate:"网络输入",
       NetworkoutRate:"网络输出",
       CpuUsageTimeSecond:"CPU使用时间(秒)",
       CpuUsageTime:"CPU使用时间",
       DiskReadBytesCountKiBS:"磁盘读取字节数(KiB/s)",
       DiskReadBytesCount:"磁盘读取字节数",
       DiskWriteBytesCountKIBs:"磁盘写入字节数(KiB/s)",
       DiskWriteBytesCount:"磁盘写入字节数",
       DiskMaxWriteOpsCount:"峰值磁盘写入操作",
       DiskMaxReadOpsCount:"峰值磁盘读取操作",
       DiskReadOpsCountTimesSec:"磁盘读取IO操作的计数(次/秒)",
       DiskReadOpsCount:"磁盘读取IO操作的计数",
       DiskPercentUsedPercentage:"磁盘使用率(百分比)",
       DiskPercentUsed:"磁盘使用率",
       CacheHitRatio:"缓存命中率",
       RedisCpuUtilization:"CPU使用率",
       KeyspaceMisses:"未命中次数",
       SystemMemoryUsageRatio:"系统内存使用率",
       UsageRatio:"内存使用率",
       ConnectionsTotal:"收到的总连接数",
        UpTime :"实例正常运行时间(s)",
        SystemUpTime:"操作系统正常运行时间(h)",
        }
    },
    // 磁盘
    disk: {
      disk: '磁盘',
      addDiskAlarm: '添加磁盘报警规则',
      editDiskAlarm: '编辑磁盘报警',
      name: '磁盘名称',
      diskId: '磁盘ID',
      capacity: '容量',
      type: '类型',
      iops: '读取速度',
      encrypted: '加密',
      region: '区域',
      state: '状态',
      deviceName: '设备名',
      volumeNotAttached: '卷未挂载',
      volumeReadWritePRIOPS: '卷读写IOPS标准值',
      volumeReadWriteOps: '卷读写IOPS',
      readIOPS: '读IOPS',
      writeIOPS: '写IOPS',
      diskList: "卷列表",
      filterByDiskId:'请输入磁盘ID',
      filterByDiskName:'请输入磁盘名称',
      diskDescription:'磁盘描述',
      diskConfig:'磁盘配置',
      diskInformation:'磁盘信息',
      // 折线图
      line:{
        DiskReadAndWriteIOPSIOPS:'磁盘读写IOPS(IOPS)',
        DiskReadIOPS:'磁盘读IOPS',
        DiskWriteIOPS:'磁盘写IOPS',
        DiskReadIOPSIOPS:'磁盘读IOPS(IOPS)',
        DiskWriteIOPSIOPS:'磁盘写IOPS(IOPS)',
        // DiskReadIOPSIOPSForecast:'磁盘读IOPS预测(IOPS)',
        // DiskWriteIOPSIOPSForecast:'磁盘写IOPS预测(IOPS)',
        DiskSpaceUsage:'磁盘空间使用率(%)',
        // DiskSpaceUsageForecast:'磁盘空间使用率预测(%)',
        TheTotalNumberOfSecondsSpentInReadAndWriteOperationsSeconds:'读取和写入操作耗费的总秒数（秒）',
        TheTotalNumberOfSecondsSpentInTheReadOperation:'读取操作耗费的总秒数',
        TheTotalNumberOfSecondsSpentInWriteOperations:'写入操作耗费的总秒数',
        TheTotalNumberOfSecondsSpentInTheReadOperationForecast:'读取操作耗费的总秒数预测',
        TheTotalNumberOfSecondsSpentInWriteOperationsForecast:'写入操作耗费的总秒数预测',
        ReadAndWriteThroughputOpss:'读写吞吐量（Ops/s）',
        ReadAndWriteThroughputOpssForecast:'读写吞吐量预测（Ops/s）',
        ReadThroughput:'读取吞吐量',
        WriteThroughput:'写入吞吐量',
        ReadThroughputForecast:'读取吞吐量预测',
        WriteThroughputForecast:'写入吞吐量预测',
        ReadAndWriteBandwidthBytes:'读写宽带（字节）',
        ReadBandwidth:'读取带宽',
        WriteBandwidth:'写入带宽',
        ReadBandwidthForecast:'读取带宽预测',
        WriteBandwidthForecast:'写入带宽预测',
        BurstBalancePercentage:'突发余额（百分比）',
        BurstBalance:'突发余额',
        AverageQueueLengthSeconds:'平均队列长度（秒）',
        AverageQueueLength:'平均队列长度',
        PercentageOfIdleTimeSeconds:'空闲花费时间百分比（秒）',
        PercentageOfIdleTime:'空闲花费时间百分比',
        SpaceUsage:"磁盘空间使用量(MB)",
        // SpaceUsageForecast:"磁盘空间使用量预测(MB)",
        InodeUtilization:"Inode使用率(%)",
        DiskReadAndWriteBPS:"磁盘读写字节数(bytes/s)",
        DiskReadBPS:"磁盘读字节数",
        DiskWriteBPS:"磁盘写字节数",
        // DiskReadBPSForecast:"磁盘读字节数预测",
        // DiskWriteBPSForecast:"磁盘写字节数预测",
        DiskReadAndWriteRequestCount:"磁盘读写请求数(count/s)",
        DiskReadRequestCount:"磁盘读请求数",
        DiskWriteRequestCount:"磁盘写请求数",
        // DiskReadRequestCountForecast:"磁盘读请求数预测",
        // DiskWriteRequestCountForecast:"磁盘写请求数预测",
        gcpDiskBytesUsed:"已使用的磁盘字节数(GiB)",
        gcpDiskIOTime:"磁盘 I/O 时间(ms/s)",
        gcpDiskOperationCount:"磁盘操作总数(count/s)"
      }
    },
    // 数据库
    database: {
      accountName: '账户',
      database: '数据库',
      name: '数据库名称',
      databaseId: '数据库实例',
      engine: '数据库引擎',
      type: '数据库类型',
      databaseInformation: '数据库信息',
      databaseConfiguration: '数据库配置',
      storage: '存储',
      storageType: '存储类型',
      addDatabaseAlarm: '添加数据库报警规则',
      editDatabaseAlarm: '编辑数据库报警规则',
      instanceType: '实例类型',
      cpuUsage: 'CPU使用率',
      memoryUsage: '内存使用率',
      diskSpaceUsage: '磁盘空间使用率',
      databaseConnections: '数据库连接数',
      instanceMaintenanceInformation: '实例维护信息',
      readThroughput: '读吞吐量',
      writeThroughput: '写吞吐量',
      readWriteIOPS: '读写IOPS',
      ioConsumptionPercent: 'IO消耗百分比',
      instanceId: '实例ID',
      state: '状态',
      region: '区域',
      filterByDBInstance: '请输入数据库实例',
      databaseList: '数据库列表',
      // 折线图
      line:{
        CPUUtilizationPercent:'CPU利用率 (百分比)',
        CPUUtilization:'CPU利用率',
        CPUUtilizationForecast:'CPU利用率预测',
        NumberOfDatabaseConnectionsNumber:'数据库连接数 (数量)',
        NumberOfDatabaseConnectionsNumberForecast:'数据库连接数预测',
        CpucreditBalance:'CPU额度余额（Count）',
        CpucreditBalanceCount:'CPU额度余额',
        CpucreditUsage:'CPU额度使用（Count)',
        CpucreditUsageCount:'CPU额度使用',
        EbsbyteBalance:'EBS 字节余额（%)',
        EbsbyteBalancePercent:'EBS 字节余额',
        EbsioBalance:'EBS IO 余额 (%)',
        EbsioBalancePercent:'EBS IO余额',
        NetworkReceiveThroughputMB:'网络接收吞吐量',
        NetworkTransmitThroughputMB:'网络传输吞吐量',
        NetworkReceiveTransmitThrough:'网络接收传输吞吐量(MB)',
        WriteReadLatency:'读写延迟(ms)',
        ReadLatencyMS:'读取延迟',
        WriteLatencyMS:'写入延迟',
        BufferCacheHitRatio:'缓冲区缓存命中率（%）',
        BufferCacheHitRatioPercent:'缓冲区缓存命中率',
        NumberOfDatabaseConnections:'数据库连接数',
        AvailableStorageSpaceBytes:'可用存储空间 (字节)',
        AvailableStorageSpace:'可用存储空间',
        AvailableStorageSpaceBytesForecast:'可用存储空间预测',
        AvailableMemoryMB:'可用内存 (%)',
        AvailableMemory:'可用内存',
        AvailableMemoryForecast:'可用内存预测',
        ReadAndWriteIOPSTimesSecond:'读写IOPS (%)',
        ReadIOPS:'读写IOPS',
        WriteIOPS:'写IOPS',
        ReadIOPSForecast:'读IOPS预测',
        WriteIOPSForecast:'写IOPS预测',
        QueueDepthNumber:'队列深度 (数量)',
        QueueDepth:'队列深度',
        BinaryLogDiskUsageMB:'二进制日志磁盘使用情况 (MB)',
        BinaryLogDiskUsage:'二进制日志磁盘使用情况',
        ReadAndWriteThroughputMBSec:'读写吞吐量 (MB/秒)',
        ReadThroughput:'读吞吐量',
        WriteThroughput:'写吞吐量',
        ReadThroughputForecast:'读吞吐量预测',
        WriteThroughputForecast:'写吞吐量预测',
        CPUUsagePercentage:'cpu使用率 (百分比)',
        CpuUsage:'cpu使用率',
        ConnectionUsagePercentage:'连接数使用率 (百分比)',
        ConnectionUsageRate:'连接数使用率',
        MemoryUsagePercentage:'内存使用率 (%)',
        MemoryUsage:'内存使用率',
        DiskUsagePercentage:'磁盘使用率 (%)',
        DiskUsage:'磁盘使用率',
        IOPSUsageRatePercentage:'IOPS使用率(%)',
        IOPSUsageRate:'IOPS使用率',
        StorageUtilizationPercentage:'存储利用率 (百分比)',
        StorageUtilization:'存储利用率',
        MemoryUtilizationPercentage:'内存利用率 (%)',
        MemoryUtilization:'内存利用率',
        ActiveConnectionsCount:'活动连接数 (Count)',
        ActiveConnections:'活动连接数',
        IOUtilizationPercentage:'IO利用率(%)',
        IOUtilization:'IO利用率',
        ProcessMemoryPercentagePercentage:'进程内存百分比 (%)',
        ProcessMemoryPercentage:'进程内存百分比',
        NumberOfSuccessfulConnectionsCount:'成功连接数 (Count)',
        NumberOfSuccessfulConnections:'成功连接数',
        NetworkInputBits:"MySQL网络入流量(bits/s)",
        NetworkInput:"MySQL网络入流量",
        NetworkOutBits:"MySQL网络出流量(bits/s)",
        NetworkOut:"MySQL网络出流量",
        SqlDiskReadOPSCount:"磁盘读取IO(Count)",
        SqlDiskReadOPS:"磁盘读取IO",
        SqlDiskWriteOPSCount:"磁盘写入IO(Count)",
        SqlDiskWriteOPS:"磁盘写入IO",
        SqlCpuUsageS:"CPU累计使用时间(s)",
        SqlCpuUsage:"CPU累计使用时间",
        SqlCpuUtilizationPercentage:"CPU利用率(%)",
        SqlCpuUtilization:"CPU利用率",
        DiskUtilizationPercentage:"磁盘利用率(%)",
        DiskUtilization:"磁盘利用率",
        SqlMemoryUtilizationPercentage:"内存利用率(%)",
        SqlMemoryUtilization:"内存利用率",
        SqlReceivedBytesByte:"网络字节数(byte)",
        SqlReceivedBytes:"网络字节数",
        NetworkConnectionsCount:"数据库连接数(Count)",
        NetworkConnections:"数据库连接数",
        MemoryTotalUsageInnoDB:"总内存使用量",
        MemoryTotalUsageInnoDBMb:"总内存使用量(MB)",
        InnodbPagesTotal:"InnoDB总页数",
        PgActiveConnections:"活跃连接数(个)",
        PgBlksReadDelta:"数据块读取数(个)",
        PgConnUsage:"连接使用率(%)",
        PgCpuTotal:"CPU使用率(%)",
        PgDbAge:"数据库未回卷xid数量(xids)",
        PgMemUsage:"内存使用率(%)",
        PgPlsDataSize:"数据盘大小(Mbyte)",
        PgPlsIops:"IOPS(次)",
        PgPlsIopsRead:"读IOPS(次)",
        PgPlsIopsWrite:"写IOPS(次)",
        PgPlsPgWalDirSize:"WAL日志大小(Mbyte)",
        PgPlsThroughput:"IO吞吐(Mbyte/s)",
        PgPlsThroughputRead:"读IO吞吐(Mbyte/s)",
        PgPlsThroughputWrite:"写IO吞吐(Mbyte/s)",
        PgRollbackRatio:"事务回滚率(%)",
        PgSwellTime:"膨胀点(s)",
        PgTps:"TPS(次)",
        rdsReplicaLag: 'RDS ReplicaLag告警(秒)',
        rdsReadOnly: '只读副本同步延迟'
      }
    },
    //弹性IP
    elasticResource:{
      elasticResource:"弹性IP",
      addEipAlarm: '添加弹性IP报警规则',
      editEipAlarm:"编辑弹性IP报警规则",
      elasticResourceList:"弹性IP列表",
      elasticResourceConfig:"弹性Ip配置",
      type:"账户类型",
      elasticResourceInformation:"弹性IP信息",
      elasticResourceId:"名称",
      allocationId:"分配id",
      instanceId:"关联实例id",
      privateIp:"私有ip",
      //折线图
      line:{
        NetrxPkgsRate:"流入包速率",
        NettxPkgsRate:"流出包速率",
        NetrxRate:"流入带宽(bit/s)",
        NettxRate:"流出带宽(bit/s)",
        NetInRatePercentage:"网络流入带宽利用率(%)",
        NetOutRatePercentage:"网络流出带宽利用率(%)",
        OutRateLimitDropSpeed:"限速丢包速率(Packets/Second)"
      },
    },
    // 财务
    billing: {
      contactGroup: "联系人组",
      contact: "联系人",
      contactWay: "联系方式",
      approval: "审批流",
      monitorIndex: '监控指标',
      pleaseSelectMonitorIndex: "请选择监控指标",
      alertRuleDesc: '报警规则描述',
      accountGroup: '账户组',
      singleAccount: '单账户',
      account: '账户',
      type: '类型',
      alertRuleName: '规则名称',
      cloudType: '云平台',
      billing: '账务',
      addBillingAlarm: '添加账务报警规则',
      editBillingAlarm: '编辑账务报警规则',
      accountGroupName: '账户组名称',
      region: '区域',
      resourceType: '资源类型',
      filterByBillingType: '请选择财务类型',
      filterByResourceType: '请输入资源类型'
    },
    // 日志
    log: {
      keyword: '关键字',
      // 应用
      application: {
        application: '应用',
        addLogAlarm: '添加日志报警规则',
        editLogAlarm: '编辑日志报警规则',
        instanceId: '实例ID',
        name: '名称',
        ip: 'IP',
        region: '区域'
      },
      // 安全
      security: {
        eventWriteType: '写类型',
        eventReadType: '读类型',
        eventAllType: '所有类型'
      },
      cloudTrail: {
        addCloudTrailAlertRule: '添加安全(CloudTrail)报警规则',
        updateCloudTrailAlertRule: '编辑安全(CloudTrail)报警规则',
        eventCheck: '事件检查'
      }
    },
    // 队列
    queue: {
      addQueue: '添加队列',
      queue: '队列',
      queueDescription: '队列描述',
      queueConfiguration: '队列配置',
      agentName: '代理名称',
      agentInstanceType: '代理实例类型',
      agentEngine: '代理引擎',
      configurationInformation: '配置信息',
      configurationName: '配置名称',
      name: '名称',
      brokerId: '代理ID',
      pleaseEnterBrokerId: "请输入代理ID",
      brokerEngine: '代理引擎',
      instanceType: '主机实例类型',
      region: '区域'
    },
    // 对象存储
    objectStorage: {
      objectStorage: '对象存储',
      objectStorageDescription: '对象存储描述',
      objectStorageConfiguration: '对象存储配置',
      configurationInformation: '配置信息',
      bucketName: '存储桶名',
      location: '地域',
      storageClass: '存储类型',
      accountName:"账户名称",
      name:"OSS名称",
      creationDateString:"创建时间",
      displayName:"创建人",
      extranetEndpoint:"外网域名",
      intranetEndpoint:"内网域名",
      displayId:"oss权限",
      access:"读写权限",
      defaultEncryption:"加密",
      region: '地区',
      objStoreName:'对象存储名称',
      pleaseEnterAccountName: "请输入账户名称",
      pleaseEnterObjStoreName: "请输入对象存储名称",
      // 折线图
      line:{
        StorageSizeBytes:'存储大小(字节)',
        StorageSize:'存储大小',
        GetAndPutRequestsNumberOfTimes:'Get、put类请求数(次数)',
        GetRequestClass:'get请求类',
        PutRequestClass:'put请求类',
        PublicNetworkOutgoingMeteredTrafficBytes:'公网流出计量流量(字节)',
        PublicNetworkOutgoingMeteredTraffic:'公网流出计量流量',
        CrossRegionReplicationOfIncomingMeteredTrafficBytes:'跨区域复制流入计量流量(字节)',
        CrossRegionReplicationOfInboundMeteringFlow:'跨区域复制流入计量流量',
        availabilityRequestValidRate:"可用性/有效请求率%",
        availability :"可用性" ,
        requestValidRate :"有效请求率",
        validRequestCountTotalRequestCount:"有效请求数/总请求数(count)",
        validRequestCount:"有效请求数",
        totalRequestCount:"总请求数",
        internetcdnsync:"流量(Byte)",
        internetSend:"公网流出流量",
        internetRecv:"公网流入流量",
        intranetSend:"内网流出流量",
        intranetRecv:"内网流入流量",
        cdnSend:"cdn流出流量",
        cdnRecv:"cdn流入流量",
        syncSend:"跨区域复制流出流量",
        syncRecv:"跨区域复制流入流量",
        // tiya
        requestCount:'请求次数',
        receivedBytesCount:'接受字节',
        sentBytesCount:'发送字节数',
        objectCount:'对象数',
        totalByteSeconds:'总字节秒数',
        totalBytes:'总字节数'
      }
    },
    // 合规检查
    complianceChecks: {
      addComplianceChecks: '添加合规检查报警规则',
      updateComplianceChecks: '编辑合规检查报警规则',
      compliance: '合规检查',
      Details:'详情',
      FilterbyResourceComplianceStatus:'请输入资源合规性状态',
      IgnoreConfirmation:'忽略确认',
      AreyouSureWantToIgnore:'你确认要忽略吗?',
      Ignore:'忽略',
      RestoreConfirmation:'恢复确认',
      AreYouSureWantToRestore:'你确认要恢复吗?',
      Restore:'恢复',
      NonCompliant:'不合规',
      Compliance:'合规',
      Account:'账号',
      Area:'区域',
      ResourceID:'资源ID',
      ResourceType:'资源类型',
      ResourceComplianceStatus:'资源合规性状态',
      RuleName:'规则名称',
      Description:'说明',
      Operating:'操作',
      AddWhitelist:'添加白名单',
      PleaseSelectAccount:'请选择账户名称',
      PleaseSelectRegion:'请选择区域',
      FilterbyComplianceRules:'请输入合规规则',
      ResourceName:'资源名称',
      SearchbyName:'请输入名称',
      AddWhitelistResources:'添加白名单资源',
      ComplianceRules:'合规规则',
      Overview:'概览',
      WhiteList:'白名单'
    },
    // 日志服务
    logService: {
      logService: '日志服务',
      logServiceDescription: '日志服务描述',
      logServiceConfiguration: '日志服务配置',
      projectName: '日志服务配置',
      logName: '日志名称',
      configurationInformation: '配置信息',
      logStoreName: '日志库名称',
      pleaseEnterLogStoreName: "请输入日志库名称",
      region: '地区',
      // 折线图
      line:{
        WriteTrafficByte:'写入流量(Byte)',
        WriteTraffic:'写入流量',
        ReadFlowByte:'读取流量(Byte)',
        ReadFlow:'读取流量',
        NumberOfOperationsCount:'操作次数(Count)',
        NumberOfOperations:'操作次数',
        OriginalDataSizeBytes:'原始数据大小(Bytes)',
        OriginalDataSize:'原始数据大小',
        ServiceStatusCount:'服务状态(Count)',
        ServiceStatus:'服务状态',
        FailedLines:"客户端解析失败行数",
        SumQps:"总体QPS",
        SuccessdByte:"客户端解析成功流量",
        InflowLine:"写入行数",
        ConsumerGroupFallBehind:"消费落后时长"
      }
    },
    // 网络
    network: {
      // CEN
      cen: {
        cen: 'CEN',
        cenDescription: 'CEN 描述',
        cenConfiguration: 'CEN 配置',
        configurationInformation: '配置信息',
        description: '描述',
        name: '名称',
        cenId: 'CEN ID',
        // 折线图
        line:{
          RegionalOutflowBandwidthPercentage:'区域流出带宽(%)',
          RegionalOutflowBandwidth:'区域流出带宽',
          GeographicalOutboundBandwidthPercentage:'地域流出带宽(%)',
          GeographicalOutflowBandwidth:'地域流出带宽',
          RegionalDelayms:'地域延时(ms)',
          RegionalDelay:'地域延时'
        }
      },
      // 负载均衡
      loadBalancing: {
        loadBalancing: '负载均衡',
        loadBalancingDescription: '负载均衡 描述',
        loadBalancingConfiguration: '配置',
        configurationInformation: '配置信息',
        instanceIp: '实例服务地址',
        region: '区域',
        name: '名称',
        loadbalancerId: '负载均衡 ID',
        ip: 'IP',
        DNSName: 'DNS名称',
        LBType: '负载均衡类型',
        status: '状态',
        vpcId: 'VPC ID',
        addLBAlarm: '添加负载均衡报警规则',
        editLBAlarm: '编辑负载均衡报警规则',
        // 折线图
        line:{
          NumberOfAbnormalBackEndECSInstancesCount:'后端异常ECS实例个数(count)',
          NumberOfAbnormalBackEndECSInstances:'后端异常ECS实例个数',
          TargetGroupHealthCheckStation:'目标群组健康状态检查(台)',
          InstancePacket:"数据包数(Count/s)",
          InstancePacketRX:'实例每秒入包数',
          InstancePacketTX:'实例每秒出包数',
          InstanceConnection:"并发连接数(Count/s)",
          InstanceActiveConnection:'实例每秒活跃连接数',
          InstanceInactiveConnection:'实例每秒非活跃连接数',
          InstanceMaxConnection:'实力每秒最大并发连接数',
          InstanceTrafficRTX:"流量(bits/s)",
          InstanceTrafficRX:"实例每秒入bit数",
          InstanceTrafficTX:"实例每秒出bit数",
          InstanceNewConnectionCount:"新建连接数(Count/s)",
          InstanceNewConnection:"实例每秒新建连接数",
          InstanceDropTrafficRTX:"丢弃流量(bits/s)",
          InstanceDropTrafficRX:"实例每秒丢失入bit数",
          InstanceDropTrafficTX:"实例每秒丢失出bit数",
          InstanceDropTrafficTXBits:"实例每秒丢失出bit数(bits/s)",
          InstanceDropTrafficRXBits:"实例每秒丢失入bit数(bits/s)",
          InstanceDropPacketRTX:"丢弃数据包数(Count/s)",
          InstanceDropPacketRX:"实例每秒丢失入包数",
          InstanceDropPacketTX:"实例每秒丢失出包数",
          InstanceDropPacketRXCount:"实例每秒丢失入包数(Count/s)",
          InstanceDropPacketTXCount:"实例每秒丢失出包数(Count/s)",
          InstanceDrops:"丢失数据数(Count/s)",
          InstanceDropConnection:"实例每秒丢失连接数",
          InstanceQpsCount:"七层实例QPS(Count/s)",
          InstanceQps:"七层实例QPS",
          InstanceQpsUtilizationPercent:"七层实例QPS使用率(%)",
          InstanceQpsUtilization:"七层实例QPS使用率",
          InstanceNewConnectionUtilizationPercent:"实例新建连接数使用率(%)",
          InstanceNewConnectionUtilization:"实例新建连接数使用率",
          InstanceMaxConnectionUtilizationPercent:"实例最大连接数使用率(%)",
          InstanceMaxConnectionUtilization:"实例最大连接数使用率",
          InstanceUpstreamRtMs:"七层协议实例UpstreamRT(ms)",
          InstanceUpstreamRt:"七层协议实例UpstreamRT",
          InstanceUpstreamCode:"七层协议实例Upstream状态码分布(Count/Second)",
          InstanceUpstreamCode4xx:"七层协议实例Upstream4XX状态码",
          InstanceUpstreamCode5xx:"七层协议实例Upstream5XX状态码",
          InstanceStatusCode:"七层协议实例状态码分布(Count/Second)",
          InstanceStatusCode2xx:"七层协议实例2XX状态码",
          InstanceStatusCode3xx:"七层协议实例3XX状态码",
          InstanceStatusCode4xx:"七层协议实例4XX状态码",
          InstanceStatusCode5xx:"七层协议实例5XX状态码",
          InstanceRtms:"七层协议实例RT(ms)",
          InstanceRt:"七层协议实例RT",
          BackendLatencies:"后端延迟",
          BackendRequestBytesCount:"后端请求字节",
          BackendRequestCount:"后端请求计数",
          BackendResponseBytesCount:"后端响应字节",
          InternalBackendLatencies:"内部负载均衡器后端延迟",
          InternalRequestCount:"内部负载均衡器请求计数",
          InternalRequestBytesCount:"请求字节",
          InternalResponseBytesCount:"内部负载均衡器响应字节",
          InternalTotalLatencies:"总延迟",
          RequestCount:"请求计数",
          ResponseBytesCount:"响应字节",
          TcpEgressBytesCount:"出口字节数",
          TcpEgressPacketsCount:"出口数据包计数",
          TcpIngressBytesCount:"入口字节数",
          TcpIngressPacketsCount:"入口数据包计数",
          TcpInternalEgressBytesCount:"内部负载均衡器出口字节数",
          TcpInternalEgressPacketsCount:"内部负载均衡器出口数据包数",
          TcpInternalIngressBytesCount:"内部负载均衡器出口字节数",
          TcpInternalIngressPacketsCount:"内部负载均衡器入口数据包数",
          TcpClosedConnections:"封闭链接",
          TcpNewConnections:"新链接已打开",
          UdpEgressBytesCount:"出口字节数",
          UdpEgressPacketsCount:"出口数据包计数",
          UdpIngressBytesCount:"入口字节数",
          UdpIngressPacketsCount:"入口数据包计数",
          UdpInternalEgressBytesCount:"内部负载均衡器出口字节数",
          UdpInternalEgressPacketsCount:"内部负载均衡器出口数据包数",
          UdpInternalIngressBytesCount:"内部负载均衡器出口字节数",
          UdpInternalIngressPacketsCount:"内部负载均衡器入口数据包数",
          UdpClosedConnections:"封闭链接",
          UdpNewConnections:"新链接已打开",
        }
      },

      AppGateway: {
        //应用程序网关
        title: "应用程序网关",
        addAppGatewayAlarm: "添加应用程序网关报警规则",
        editAppGatewayAlarm: '编辑应用程序网关报警规则',
        resourceGroup: "资源组",
        // 折线图
        line:{
          ThroughputByte:'吞吐量（Byte）',
          Throughput:'吞吐量',
          NumberOfConnectionsCount:'连接数（个）',
          NumberOfConnections:'连接数'
        }
      },
      AppService: {
        addAppServiceAlertRule: '添加应用程序服务报警规则',
        updateAppServiceAlertRule: '编辑应用程序服务报警规则',
        //应用程序服务
        title: "应用程序服务",
        add: "添加应用程序服务报警规则",
        name: "名称",
        status: "状态",
        appType: "应用类型",
        appPlan: "应用服务计划",
        resourceGroup: "资源组",
        location: "位置",
        subscription: "订阅",
        description: "应用程序服务描述",
        appConfig: "应用程序服务配置",
        subscriptionID: "订阅ID",
        subscriptionName: "订阅名称",
        appServiceInfo: "应用程序服务信息",
        time:"时间",
        // 折线图
        line:{
          CPUTimeseconds:'CPU Time（秒）',
          MemorySetbytes:'内存集（字节）',
          MemorySet:'内存集',
          ResponseTimeseconds:'响应时间（秒）',
          ResponseTime:'响应时间'
        }
      },
      //nat网关
      nat:{
        nat:"NAT网关",
        natList:"NAT网关列表",
        region:"区域",
        name:"网关名称",
        natGatewayId:"nat网关ID",
        state:"状态",
        publicIp:"公有IP",
        privateIp:"私有IP",
        vpcId:"VPC",
        createTime:"创建时间",
        natConfig:"nat网关配置",
        natInformation:"nat网关信息",
        line:{
          SessionActiveLimitDropConnectionCount:"并发连接数/并发丢弃连接速率(CountS)",
          SessionActiveConnectionCount:"并发连接数",
          SessionLimitDropConnectionCount:"并发丢弃连接速率",
          SessionNewLimitDropConnectionCount:"新建连接速率/新建丢弃连接速率(CountS)",
          SessionNewConnectionCountS:"新建连接速率",
          SessionNewLimitDropConnectionCountS:"新建丢弃连接速率",
          SessionActiveNewConnectionWaterLever:"并发连接水位/新建连接水位（%）",
          SessionActiveConnectionWaterLever:"并发连接水位",
          SessionNewConnectionWaterLever:"新建连接水位",
          BWRateInFromOutToInsideBps:"入方向流量速率(Bps)",
          BWRateInFromOutsideBps:"从公网来流量速率",
          BWRateOutToInsideBps:"入VPC流量速率",
          BytesInFromOutOutToInsideByte:"入方向流量(Byte)",
          BytesInFromOutsideByte:"从公网来流量",
          BytesOutToInsideByte:"入VPC流量",
          PPSRateInFromOutOutToInsideCount:"入方向包速率(CountS)",
          PPSRateInFromOutsideCount:"从公网来包速率",
          PPSRateOutToInsideCount:"入VPC包速率",
          PacketsInFromOutOutToInsideCount:"入方向包量(Count)",
          PacketsInFromOutsideCount:"从公网来包量",
          PacketsOutToInsideCount:"入VPC包量",
          BWRateInFromInOutToOutsideBps:"出方向流量速率(Bps)",
          BWRateInFromInsideBps:"从VPC来流量速率",
          BWRateOutToOutsideBps:"入公网流量速率",
          BytesInFromInOutToOutsideByte:"出方向流量(Byte)",
          BytesInFromInsideByte:"从VPC来流量",
          BytesOutToOutsideByte:"入公网流量",
          PPSRateInFromInOutToOutsideCountS:"出方向包速率(CountS)",
          PPSRateInFromInsideCountS:"从VPC来包速率",
          PPSRateOutToOutsideCountS:"入公网包速率",
          PacketsInFromInOutToOutsideCount:"出方向包量(Count)",
          PacketsInFromInsideCount:"从VPC来包量",
          PacketsOutToOutsideCount:"入公网包量"

        }
      }
    },
    //SLS
    sls:{
      sls:"SLS",
      slsList:"SLS列表",
    },
    //autoscaling
    autoscaling:{
      autoscaling:"弹性伸缩",
      autoscalingList:"弹性伸缩列表",
      accountIdString:"账号ID",
      accountName:"账号Name",
      scalingGroupId:"弹性伸缩组id",
      scalingGroupName:"弹性伸缩组name",
      groupType:"实例类型",
      vpcId:"VPC ID",
      totalInstanceCount:"ECS实例的数量",
      lifecycleState:"状态信息",
      minSize:"ECS实例台数的最小值",
      maxSize:"ECS实例台数的最大值",
      scalingPolicy:"指定伸缩组的回收模式",
      healthCheckType:"伸缩组的健康检查方式",
      autoscalingConfig:"弹性伸缩网关配置",
      autoscalingInformation:"弹性伸缩网关信息",
      line:{
        MaxInstanceCount:"最大实例数",
        MinInstanceCount:"最小实例数",
        PendingInstanceCount:"正在加入实例数",
        RemovingInstanceCount:"正在移除实例数",
        RunningInstanceCount:"运行实例数",
        TotalInstanceCount:"总实例数"
      }
    },
    WebApplicationFirewall:{
      WebApplicationFirewall:"Web应用防火墙",
      WebApplicationFirewallList:"Web应用防火墙列表",
      accountName:"账户名称",
      accountIdString:"账户ID",
      region:"区域",
      instanceId:"实例id",
      statusName:"是否过期",
      versionName:"版本",
      WebApplicationFirewallConfig:"Web应用防火墙配置",
      configurationInformation: '配置信息',
      InstanceId:"实例ID:",
      createdTime: '创建时间',
      line:{
        Qps:"QPS",
        QpsCounts:"QPS(countS)",
        QpsRatio:"QPS环比增长率",
        QpsRatioPercent:"QPS环比增长率(%)",
        QpsRatioDown:"QPS环比下降率",
        QpsRatioDownPercent:"QPS环比下降率(%)",
      }
    },
    // Redshift
    redshift: {
      addRedshiftAlarm: '添加数据仓库报警规则',
      addDocDBAlarm: '添加DocDB报警规则',
      editRedshiftAlarm: '编辑数据仓库报警规则',
      cluster: '集群',
      accountName: "账户名称",
      nodeType: '类型',
      nodeSize: '节点数',
      redshiftList: '数据仓库列表',
      redshiftName: "数仓名称",
    },
    // elasticSearch
    elasticSearch: {
      addEsAlarm: '添加ElasticSearch报警规则',
      editEsAlarm: '编辑ElasticSearch报警规则',
      esDomain: "ES域名",
      elasticSearchList: 'ElasticSearch列表',
      filterByEsDomainName: '请输入ES域名',
      clusterStatus:'集群状态',
      blockWriteRequest:'阻止写入请求',
      numberOfNodes:'节点数量',
      automaticSnapshotFailed:'自动快照失败',
      kMSKeyError:'KMS密钥错误',
      kMSKeyCannotBeAccessed:'KMS密钥无法访问',
      dataNodeCPUUsage:'数据节点CPU使用率',
      dataNodeJVMMemoryPressure:'数据节点JVM内存压力',
      cPUUsageOfTheMasterNode:'主节点CPU使用率',
      JVMMemoryPressureOnTheMasterNode:'主节点JVM内存压力',
      dataNodeRemainingStorageSpace:'数据节点剩余存储空间%',
      green:'绿色',
      yellow:'黄色',
      red:'红色'
    },
    // redis
    redis: {
      addRedisAlarm: '添加Redis报警规则',
      editRedisAlarm: '编辑Redis报警规则',
      redisList: 'Redis列表',
      filterByCacheClusterId: '请输入节点名称',
      redisDescription:'Redis描述',
      redisConfig:'Redis配置',
      redisInfo:'Redis信息',
      cacheClusterId:'节点名称',
      currConnectionAmount:'当前连接数(数量)',
      currConnection:'当前连接数',
      bytesUsedForCacheByte:'缓存字节数(字节)',
      bytesUsedForCache:'缓存字节数'
    },
    // 云用户
    cloudUser: {
      title:"云用户",
      cloudUserList:"云用户列表",
      addCloudUserAlarm: '添加云用户报警规则',
      editCloudUserAlarm: '编辑云用户报警规则',
      cloudUserName: '云用户'
    },
    // 邮箱
    mailbox: {
      title:"邮箱",
      addMailBoxAlarm: '添加邮箱报警规则',
      editMailBoxAlarm: '编辑邮箱报警规则',
      monitoringMailBox: '监控邮箱'
    },
    // 网站健康状态
    websiteHealthStatus: {
      title:"网站健康状态",
      addWebsiteHealthStatusAlarm: '添加网站健康状态报警规则',
      editWebsiteHealthStatusAlarm: '编辑网站健康状态报警规则',
      host: '网站地址',
      port: '端口',
      timeout: '连接超时时间'
    },
    // 报警规则公用项
    common: {
      dynamicHeader:'动态表头',
      alertContact: '联系人',
      alertContactGroup: '联系人组',
      weChatTemplate: '微信模板',
      phoneTemplate: '电话模板',
      emailTemplate: '邮箱模板',
      monitoringTime: '监控时段',
      delayAlarm: '延迟告警',
      alarmType: '报警方式',
      pleaseSelect: '请选择',
      unit: '单位',
      threshold: '阈值',
      continuous: '连续周期',
      volatility: '波动率',
      checkCycle: '检测周期',
      tips: '由于利用率和覆盖率有延迟性，故检测时间是从当前时间向前推2天开始。举例：当前如果为：2023-11-20日，检测周期如为30天，则周期内的时间范围为：2023.10.18-2023.11.18',
      tooltips: '检测周期为近30天',
      cycle: '周期',
      sign: '符号',
      statisticsValue: '统计数值',
      ok: '确认',
      addAlarm: '添加告警',
      addWhitelist: '添加白名单',
      search: '查询',
      nextStep: '下一步',
      lastStep: '上一步',
      cancel: '取消',
      edit: '编辑',
      add: '添加',
      delete: '删除',
      details: '详情',
      deleteConfirmation: '删除确认',
      sureDelete: '你确认要删除',
      sureDeletes: '你确认要删除吗',
      sureRunImmediately:"你确定要立即运行",
      allWarningRules: '下所有相关的告警规则吗',
      createdTime: '创建时间',
      monitorMessage: '监控信息',
      monitorItems: '监控项',
      viewMonitoringOverview: '查看监控概览',
      viewForecastMonitoringOverview: '查看预测监控概况',
      alertRule: '报警规则',
      untreated: '未处理案例',
      viewAlarmRules: '查看报警规则 ',
      tags: '标签',
      count: '项',
      what: '吗',
      seriousProblems: '项严重问题',
      hostDescription: '主机描述',
      allRegion: '全部区域',
      monitoringSummary: '监控概览',
      refresh: '刷新',
      alertRuleName: '规则名称',
      status: '状态',
      monitorIndex: '监控指标',
      contact: '通知对象',
      scanType: '类型',
      delayType: '延迟类型',
      delayCountdown: '延迟倒计时(小时)',
      accountName: '账户名称',
      account: '账户',
      accountType: '账户类型',
      region: '存储区域',
      accountGroupName: '账户组名称',
      billingType: '财务类型',
      alertRuleDesc: '报警规则描述',
      resourceType: '资源类型',
      allResourceType: '所有资源类型',
      back: '返回',
      pleaseSelectCompany: '请选择公司',
      pleaseSelectRegions: '请选择区域',
      all: '全部',
      allSelected: '全选',
      filterByAlertRuleName: '请输入规则名称',
      filterByAccountType: '请选择账户类型',
      filterByAccountName: '请输入账户名称',
      filterByNatGatewayId:"请输入Nat网关ID",
      filterNatGatewayId: '请输入NAT网关ID',
      filterOssName:"请输入oss名称",
      filterByVpcName:"请输入vpc名称",
      filterByInstanceId: '请输入实例ID',
      filterByInstanceName: '请输入实例名称',
      filterByScalingGroupName:"请输入弹性伸缩名称",
      filterByLoggingstoredName:"请输入日志存储名称",
      filterByLoggingRouteName:"请输入日志路由名称",
      filterByProjectName:"请输入项目名称",
      filterByIpAddress: '请输入IP地址',
      filterByTagKey: '请输入标签KEY',
      filterByTableName: '请输入表名称',
      pleaseSelectAccount: '请选择账户名称',
      pleaseSelectStatus: '请选择状态',
      pleaseSelectCategory: '请选择类型',
      pleaseSelectDelayType: '请选择延迟类型',
      operationLog: '操作日志',
      pleaseInputValue: '请输入值',
      ruleName: '规则名称',
      monitoringMethod: '监控方法',
      ruleDescription: '规则描述',
      continuousCycle: '连续周期',
      statisticsCount: '统计次数',
      symbol: '符号',
      minimum: '最小值',
      max: '最大值',
      logGroupName: '日志组名称',
      contactType: '联系方式',
      notificationObject: '通知对象',
      contactPerson: '联系人',
      contactGroup: '联系人组',
      noticeType: '报警方式',
      alarmDelay: '延迟告警',
      monitorPeriod: '监控时段',
      emailModal: '邮箱模板',
      wechatModal: '微信模板',
      phoneModal: '微信模板',
      approvalFlow: '审批流',
      cloudPlatform: '云平台',
      standardValue: '标准值',
      routineMonitoring: '常规监控',
      intervalMonitoring: '异常检测监控',
      warning:'警告提示',
      wechatTip:'目前没有微信联系人，请取消微信通知渠道并继续！',
      phoneTip:'目前没有电话联系人，请取消电话通知渠道并继续！',
      enable: '启用',
      disable: '禁用',
      manual: '手动',
      automatic: '自动',
      fiveMinutes:'5分钟',
      fifteenMinutes:'15分钟',
      oneHour:'1小时',
      sixHour:'6小时',
      oneDay:'一天',
      Empty:'清空',
      SelectionPeriod:'选择时间',
      close:'关闭',
      enterpriseWeChatRobotURL:'企业微信机器人URL',
      publicIp:"弹性IP",
      resourceSyncLog: "资源同步记录"
    },
    // 存储网关
    storagegateway: {
      storagegateway:'存储网关',
      storagegatewayList:'存储网关列表',
      addAlertRule:'添加存储网关告警规则',
      filterByStorageGatewayName:'请输入存储网关名称',
      storageGatewayName:'存储网关名称',
      addStorageGatewayAlarm:'添加存储网关告警',
      storageGatewayDetail:'存储网关详情' ,
      storageGatewayConfig:'存储网关配置',
      storageGatewayInfo:'存储网关信息',
      editStorageGatewayAlarm: '编辑存储网关告警规则'
    },
    //备份计划
    backPlan:{
      backPlan:"备份计划",
      addBackPlanAlarm:"添加备份计划报警规则",
      backPlanList:"备份计划列表",
      accountTypeName:"账户类型",
      accountName:"账户名称",
      backupPlanId:"备份计划id",
      backupPlanName:"备份计划名称",
      creationDate:"创建日期",
      region:"区域",
      addBackupPlanAlarm:"添加备份计划报警规则",
      editBackupPlanAlarm:"添加备份计划报警规则",
    }






  },
  // 实例列表
  instance_list: {
    swireInstanceList: '太古实例列表',
    environment: '环境',
    instanceName: '实例名称',
    usageDetail: '使用细节',
    availableZone: '可用区',
    privateIP: '私有IP',
    CPUNumber: 'CPU数量',
    mem: '内存(GB)',
    disk: '磁盘(GB)',
    project: '项目',
    business: '业务',
    owner1: '拥有者1',
    owner2: '拥有者2',
    os: '操作系统',
    env: 'Env',
    billingType: 'Billing Type',
    selectByEnvironment: '请输入环境',
    selectByDate: '请选择日期'
  },
  // 报警联系人
  alarm_contact: {
    allType: '全部类型',
    contact: '联系人',
    contactGroup: '联系人组',
    selectByCompany: '请选择公司',
    selectByName: '请输入用户姓名',
    alarmContact: '报警联系人',
    alarmContactSearchKeyPlaceholder: '请输入姓名',
    addAlarmContact: '添加联系人',
    companyName: '公司名称',
    name: '用户',
    dept: '部门',
    position: '职务',
    monitorModule: '监控模块',
    phone:'电话',
    email: '邮箱',
    wechat: '企业微信',
    defaultContact: '默认联系人',
    alarmContactReplacement: '报警联系人替换',
    del: "删除",
    addContact: "添加联系人组",
    contactGroupName: "联系人组名称",
    selectByContactGroupName: "请输入联系人组名称",
    default: "是否默认",
    description: "描述",
    contactGroupConfig: "配置",
    operationLog: "操作日志",
    replace: "替换",
    replaceTip: "将当前联系人的报警规则，替换到新的联系人下!",
    bindingStatus: "绑定状态",
    personalWeChat: "个人微信",
    yes: "是",
    no: "否",
    unBind: "解除绑定",
    isBinding:'已绑定',
    editContact: "编辑报警联系人",
    contactConfiguration: "联系人配置",
    enterpriseWechatRobot: "企业微信机器人",
    searchByRobotName: "请输入机器人名称",
    add: "添加",
    edit: "编辑",
    robotName: "机器人名称"
  },
  // 定时开关机
  schedule_instance_config: {
    start:'启动',
    pause:'暂停',
    close:'关闭',
    exception:'例外',
    ip: 'IP',
    instanceName: '实例名称',
    AWSType: "AWS资源类型",
    instanceUsage: '实例用途',
    instanceStatus: '实例状态',
    isWorkDay: '是否工作日',
    scheduleOpenInstanceTime: '开机时间',
    scheduleCloseInstanceTime: '关机时间',
    isException: '是否例外',
    exceptionStartDate: '例外开始日期',
    exceptionEndDate: '例外结束日期',
    exceptionStartTime: '例外开机时间',
    exceptionEndTime: '例外关机时间',
    hasScheduledTask: '有定时任务',
    timeSwitch: '定时开关机',
    search: '查询',
    timeSwitchTask: '定时开关机任务',
    selectByCompany: '请选择公司',
    selectByIp: '请输入IP',
    add: '添加',
    addSystemTask: '添加定时任务',
    editSystemTask: '编辑定时任务',
    status: '状态',
    approvalFlow: '审批流',
    instance: '实例',
    reason: '申请原因',
    yes: '是',
    no: '否',
    workDay: '工作日',
    everyDay: '每天',
    virtualHost: '虚拟主机',
    virtualDesktop: '虚拟桌面',
    del: '删除',
    performType:'执行类型'
  },
  audit_task: {
    auditTask: '审核任务',
    ip: 'IP',
    operator: '操作员',
    auditor: '审核员',
    auditStatus: '审核状态',
    operationType: '操作类型',
    createdTime: '创建时间',
    denialReason: '驳回原因',
  },
  configuration_management: {
    // 邮箱配置管理
    mailbox_management: {
      email: "邮件",
      monitorMailboxConfiguration: "监控邮箱配置",
      processEmails: "待处理邮件主题",
      emailSubject: '邮件主题',
      addEmail: '添加邮箱',
      editEmail: '编辑邮箱',
      addEmailSubjectKeyword: '添加邮件主题关键词',
      editEmailSubjectKeyword: '编辑邮件主题关键词',
      emailSubjectKeyword: '邮件主题关键词',
      company: '公司',
      emailName: '邮箱名称',
      host: '主机地址',
      port: '端口',
      userName: '用户名',
      password: '密码',
      describe: '描述',
      queryByKeyWord: '请输入关键词',
    },
    // 预留实例购买
    reserved_instance_purchase : {
      title: '预留实例购买配置',
      riFamily: "实例家族",
      size: "实例大小",
    },
    // schedules
    schedules: {
      title: "调度管理",
      addSchedule: "添加日程",
      editSchedule: "编辑日程",
      name: "名称",
      repetition: "重复",
      start: "开始时间",
      frequency: "调度",
      enableWeekdays: "周天",
      end: "结束时间",
      startFor: "启用于",
      describe: "描述",
      minute: "分钟",
      hour: "小时",
      day: "天",
      week: "周",
      month: "月",
      Monday: "星期一",
      Tuesday: "星期二",
      Wednesday: "星期三",
      Thursday: "星期四",
      Friday: "星期五",
      Saturday: "星期六",
      Sunday: "星期天",
      queryByName: "请输入名称",
    },
    // System Task
    system_task: {
      addSystemTask: '添加定时任务',
      configureSystemTask: '定时任务配置',
      taskID: '任务ID',
      beanName: 'bean名称',
      methodName: '方法名称',
      methodParameter: '方法参数',
      cronExpressioin: 'cron表达式',
      note: '备注',
      ok: '正常',
      paused: '暂停',
    },
    // Customized Alarm Config
    customized_alarm_config: {
      customizedAlarmConfig: '客户自定义报警配置',
      listOfAlarmRules: '报警规则一览表',
      cloudType: '全部类型',
      version: '版本号',
      isAutoDelayEnroll: '注册自动延迟',
      addVolume: "添加磁盘",
      checkAll: "全选",
      checkTheListOfAlarmRules: "查看报警规则一览表",
      setUpAUniversalAIAlarmHandlingProcess: '设置通用AI报警处理流程',
      defaultApprovalFlow: '默认审批流',
      alarmValidityPeriod: '报警有效期(分钟)',
      alarmValidityPeriodSecond: '报警有效期(秒)',
      noticeType: '通知方式',
      exceptionResources: "例外资源",
      AIMonitoringAlarm: 'AI监控报警',
      AIMonitorsTheAlarmStatus: 'AI监控报警状态',
      editAIAlarmProcess: '编辑AI报警流程',
      whetherToEnableEmailNotifications: '是否启用邮件通知',
      editGeneralAIAlarmProcess: '编辑通用AI报警流程',
      pleaseEnterTheProcessContent: '请输入流程内容',
      identification: '识别',
      pleaseConfigureTheNotificationTemplate: '请配置通知模板',
      configureSeparateAIAlarmProcess: '配置单独AI报警流程',
      recipient: '收件人',
      usingResources:'使用资源',
      alertRuleDesc:'具体内容',
      delayName:'延迟类型',
      alarmDelayCountdown:'延迟倒计时'
    },
    // Default Alarm Config
    default_alarm_config: {
      defaultAlarmConfig: '默认报警配置',
      addDefaultAlarmConfig: '添加默认报警配置',
      editDefaultAlarmConfig: '添加默认报警配置',
      addAlarm: '添加报警',
      version: '版本号',
      cloudPlatform: '云平台',
    },
    //配置管理通用
    common: {
      all: '全部',
      cloudType: '全部类型',
      sequenceId: '序号',
      accountType: '账户类型',
      cycle: '周期',
      continuous: '连续周期',
      statisticsValue: '统计数值',
      statisticsCount: '统计次数',
      resourceType: '资源类型',
      sign: '符号',
      threshold: '阈值',
      unit: '单位',
      priority: '优先级',
      standardValues: '标准值',
      type: "类别",
      ruleDescription: "规则描述",
      monitorModule: '监控模块',
      logGroupName: '日志组名称',
      monitorPeriod: '监控时间段',
      alarmWayList: '报警方式',
      isAutoDelayEnrollTypeList: '是否注册自动延迟',
      pleaseSelectCompany: '请选择公司',
      operationLog: '操作日志',
      deleteButton: '删除',
      pleaseSelectStartTime: '请选择开始时间',
      pleaseSelectEndTime: '请选择结束时间',
      selectButton: '查询',
      changeField: '变更字段',
      originalValue: '原值',
      newValue: '新值',
      operator: '操作人',
      operatingTime: '操作时间',
      pleaseSelect: '请选择',
      save: "保存",
    }
  },
  permission_configuration_management: {
    //权限模块通用
    common:{
      all: '全部',
      pleaseInput:'请输入',
      pleaseSelect:'请选择',
      edit:'编辑',
      enable: '启用',
      disable: '禁用',
      cancel:'取消',
      confirm:'确定',
      delete:'删除',
      operationLog: '操作日志',
      pleaseSelectCompany:'请选择公司',
    },
    // 策略一览
    permission:{
      permissionOverview:'策略一览',
      permissions:'策略',
      authorized:'是否授权',
      templateName:'策略类型'
    },
    // 账号管理
    account: {
      cancel:'取消',
      confirm:'确定',
      delete:'删除',
      elk:'ELK',
      protogenesis:'原生',
      overseas:'海外',
      china:'中国',
      all:'全部',
      pleaseSelectCompany:'请选择公司',
      checkByAccountName:'请输入账户名',
      subscriptionId: '订阅ID',
      subscriptionName: '订阅名称',
      accessKeyID: '访问密钥ID',
      secretAccessKey: '访问密钥Key',
      roleSessionName: '角色会话名称',
      roleArn: '角色ARN',
      externalId: '外部ID',
      scanResources: '扫描资源',
      account: '账户',
      company: '公司',
      addAccount: '添加账户',
      editAccount: '编辑账户',
      searchNewResource: '新资源发现',
      accountName: '账户名',
      scanResource: '扫描资源',
      accountType: '账户类型',
      accountId: '账户ID',
      area: '地区',
      region: '区域',
      authType: '认证方式',
      dataSource: '数据源',
      accountRegister: '账号注册',
      labelScanInterval: '标签扫描间隔',
      contactType: '联系方式',
      contact: '联系人',
      contactGroup: '联系人组',
      isCoverDefault: '扫描已存在自定义告警的资源',
      immediatelyScan: '立即扫描',
      update: '更新',
      operationLog: '操作日志',
      enable: '启用',
      disable: '禁用',
    },
    // 注册
    register:{
      UserName:'用户名',
      FullName:'全名',
      Company:'公司',
      Department:'部门',
      Position:'职务',
      Mailbox:'邮箱',
      Password:'密码',
      ConfirmPassword:'确认密码',
      Register:'注册',
      ExistingAccountLogin:'已有账号登录',
      SendTheVerificationCode:'发送验证码',
      VerificationCode:'验证码',
      NextStep:'下一步',
      ResetPassword:'重置密码',
      Warning:'警告提示',
      ResetTip:'密码输入错误已达5次,更改密码功能已被锁定,请1个小时之后再访问该功能!',
      Cancel:'取消',
      Reset:'重置'
    },
    smsLogin:{
      telPhone:'手机号码',
      SMSAuthenticationLogin:'短信验证登录',
      plaTelPhone:'请输入手机号码',
      rightTelPhone:'请输入正确的手机号码',
      plaVerificationCode:'请输入验证码',
      getVerificationCode:'获取验证码',
      surplusTime:'后重发',
      Reacquire:'重新获取',
      verificationCode:'验证码',
      product:'产品',
      subscribe:'订阅',
      doc:'使用手册',
      TrialVersion:'试用版',
      trialVersionDesc:'为团队协作量身打造，提升协作效能',
      function:'产品功能',
      Dashboard:'仪表盘',
      ResourceAlarmManagement:'资源告警管理（部分资源）',
      CaseWorkOrderSystem:'案例工单系统',
      AlarmContact:'报警联系人',

      BillManagement:'账单服务（AWS）',
      CMDBFunctionSomeResources:'CMDB功能（部分资源）',

      ReservedInstances:'预留实例',

      PermissionConfigurationManagement:'权限配置管理',

      OfficialEdition:'企业版',
      trialVersionDescOfficial:'产品研发全生命周期覆盖',
      OfficialFunction:'试用版全部功能，以及',
      InstrumentClusterEnhanced:'仪表盘[加强版]',

      ResourceAlarmManagementEnhancedVersion:'资源告警管理[加强版]',


      TimingSwitch:'定时开关机',

      ApprovalProcess:'审批流',

      BillManagementEnhancedVersion:'账单服务[加强版]',

      PachEasy:'PachEasy',

      ConfigurationManagementEnhanced:'配置管理[加强版]',

      IntelligentMonitoring:'智能监控',
      FreeTrial:'免费试用',
      applyTrial:'申请试用',
      UserManual:'使用手册',
      QuickStartGuide:'快速上手指南',
      ComingSoon:'敬请期待...',
      adminGuide:'管理员手册',
      ResourceLabelManagement:'资源标签管理',
    },
    // User
    user: {
      newPassword:'新密码',
      currentPassword:'当前密码',
      resetPassword:'重置密码',
      enable: '启用',
      disable: '禁用',
      offLine:'离线',
      onLine:'在线',
      checkByUserName:'请输入用户名',
      pleaseSelectCompany:'请选择公司',
      all:'全部',
      confirmPassword: '确认密码',
      password: '密码',
      addUser: '添加用户',
      editUser: '编辑用户',
      userManagement: '用户管理',
      userName: '用户名称',
      companyName: '公司名称',
      email: '邮箱',
      fullName: '全名',
      department: '部门',
      position: '职务',
      role: '角色',
      loginStatus: '登陆状态',
      accountStatus: '账号状态',
      SMSVerification:'开启短信验证',
      SMSVerificationStatus:'开启短信验证状态',
    },
    // Role
    role: {
      editRole:'编辑角色',
      companyName: '公司名称',
      roleManagement: '角色管理',
      addRole: '添加角色',
      roleName: '角色名称',
      menuData: '菜单权限',
      remark: '备注',
      checkByRoleName:'请输入角色名称',
    },
    // Group
    group: {
      companyName:'公司名称',
      checkByVirtualDesktopID:'请输入虚拟桌面ID',
      addVirtualDesktop:'添加虚拟桌面',
      virtualDesktopID:'虚拟桌面ID',
      databaseEngine:'数据库引擎',
      cloudPlatform:'云平台',
      addDatabase:'添加数据库',
      status:'状态',
      encryption:'加密',
      readingSpeed:'读取速度',
      type:'类型',
      deviceName:'设备名',
      name:'名称',
      volumeID:'磁盘ID',
      addVolume:'添加磁盘',
      checkByVolumeId:'请输入磁盘ID',
      tags:'标签',
      privateIP:'私有IP',
      region: "区域",
      instanceName: "实例名称",
      instanceID: "实例ID",
      instanceType: "实例类型",
      diskStorage: "储存大小（GB）",
      addInstance:'添加实例',
      checkByPrivateIP:'请输入私有IP',
      checkByInstanceId:'请输入实例ID',
      checkByAccountType:'请输入账户类型',
      checkByAccountName:'请输入账户名',
      checkByStorageGatewayId:'请输入存储网关',
      addStorageGateway:'添加存储网关',
      accountType: '账户类型',
      accountId: '账户ID',
      accountName:'账户名称',
      addAccount:'添加账户',
      backGroup:'返回组',
      addUser:'添加用户',
      virtualDesktop:'虚拟桌面',
      database:'数据库',
      disks:"磁盘",
      instance:'实例',
      account:'账户',
      user:'用户',
      accessConfiguration:'权限配置',
      groupManagement: '组管理',
      addGroup: '添加组',
      configPermission: '权限配置',
      groupName: '组名称',
      checkByGroupName:'请输入组名称',
      storageGateway:'存储网关',
      storageGatewayID:'存储网关ID',
      storageGatewayName:'存储网关名称',
    },
  },
  // 公共
  common: {
    // 操作
    operation: '操作',
    operationLog: '操作日志',
    addAlarm: '添加报警',
    editAlarm: '编辑报警',
    export: '导出',
    exportInstanceAlarmRule: '导出实例报警规则',
    exportRDSAlarmRule: '导出数据库报警规则',
    exportMetricsStatistics: '导出指标统计',
    exportStatistics: '导出统计',
    del: '删除',
    edit: '编辑',
    login: '登录',
    register: '注册新账号',
    activate: '激活',
    inActivate: '禁用',
    note: '备注',
    ok: '确认',
    configure: '配置',
    forgetPassword: '忘记密码',
    changePassword: '修改密码',
    userName:'用户名',
    password:'密码',
    submit:'提交',
    determine:'确定',
    singleAccount: '单账户',
    accountGroup: '账户组',
    noData:'暂无数据',
    notice:'通知',
    noticeContent:'你有一条新的待办事项',
    yes:'是',
    no:'否'
  },
  // 操作日志
  operation_log: {
    operationLog: "操作日志",
    changeField: "变更字段",
    operationMonitorModuleName: "操作模块",
    operationFieldName: "操作字段",
    operationOriginValue: "原值",
    operationNewValue: "新值",
    createdBy: "操作人",
    search: "查询",
    pleaseSelectStartTime: "请选择开始时间",
    pleaseSelectEndTime: "请选择结束时间",
    createdTime: "更新时间"
  },
  patch_management: {
    // 补丁监视器
    patch_monitor: {
      patchMonitor: '补丁监视器',
      awsSSMOverview: '概述',
      instanceType: '实例类型',
      patchedInstancesByOS: '已打补丁的实例（操作系统）',
      patchedInstance: '补丁实例',
      id: '实例ID',
      name: '名称',
      missingCount: '丢失数',
      installedCount: '安装数量',
      installedOtherCount: '安装其他数量',
      notApplicableCount: '未打补丁数量',
      notPatchedInstances: '未打补丁实例'
    },
    //补丁策略
    patch_policy: {
      deletePolicy:"删除策略",
      runImmediately:"立即运行",
      start:"开启",
      close:"关闭",
      active:"启用",
      inactive:"禁用",
      addPolicy:"添加策略",
      editPolicy:"编辑策略",
      name:"名称",
      policyName: "策略名称",
      account:"账户",
      region:"区域",
      queryByRegion:"请输入区域",
      state:"状态",
      remindTime:"提醒时间",
      contactType:"联系方式",
      contactPerson:"通知对象",
      contactGroup:"联系人组",
      approvalFlow:"审批流",
      schedule:"日程",
      description:"描述",
      cancel:"取消",
      confirm:"确定",
      submit:"提交",
      queryByName:"请输入名称",
      queryByPolicyName: "请输入策略名称",
      patchDetail:"补丁详情",
      releaseDate:"发行日期",
      title:"名称",
      vendor:"供应商",
      productFamily:"产品系列",
      product:"产品",
      classification:"分类",
      severity:"严重级别",
      number:"编号",
      language:"语言",
      patchBaselineDetail:"补丁基准详情",
      baselineId:"基准ID",
      baselineName:"基准名称",
      os:"操作系统",
      defaultBaseline:"默认基准",
      patchGroup:"补丁组",
      createdDate:"创建日期",
      modifiedDate:"修改日期",
      queryByAccount:"请输入账号",
      queryBySeverity:"请输入严重级别",
      search:"搜索",
      queryByOS:"请输入操作系统",
      patchBaseline:"补丁基准",
      patch:"补丁",
      selectAll:"全选",
      priority: "优先级",
      addPatchBaseline:"添加补丁基准",
      editPatchBaseline:"编辑补丁基准",
      add:"添加",
      edit:"编辑",
      yes:"是",
      no:"否",
      CommandParameters:"命令参数",
      Operating:"操作",
      SnapshotId:"快照Id",
      InstallationCoverageList:"安装覆盖列表",
      WhetherToBackup:"是否备份",
      InAdvance:"提前",
      MinuteBackup:"分钟备份",
      WhetherTheBackupFailsToContinue:"备份失败是否继续",
      BackupRetention:"备份保留",
      Day:"天",
      Aims:"目标",
      SpecifyTargetMethod:"指定目标方式",
      SpecifyLabel:"指定标签",
      ManuallySelectInstance:"手动选择实例",
      KeyUpToCharacters:"键 （最多128个字符）",
      ValueUpToCharacters:"值 （最多256个字符）",
      Delete:"删除",
      AddTag:"添加标签",
      OtherParameters:"其他参数",
      Comment:"注释",
      TimeoutSeconds:"超时(秒)",
      OutputOptions:"输出选项",
      Tip:"将命令输出写入Amazon S3 存储桶",
      EnableBucketWriting:"启用S​​3 存储桶写入",
      WriteCommandOutputToAmazonCloudWatchLog:"将命令输出写入Amazon CloudWatch 日志",
      CloudWatchOutput:"CloudWatch 输出",
      TargetInstance:"目标实例",
      QuerybyInstanceID:"请输入实例ID",
      InstanceID:"实例 ID",
      ProxyVersion:"代理版本",
      status:"状态",
      AvailableArea:"可用区域",
      platform:"平台",
      S3BucketName:"S3 存储桶名称",
      S3KeyPrefixOptional:"S3密钥前缀 - 可选",
      LogGroupNameRequired:"日志组名称 - 必选",
      save:"保存",
      //Input Validation
      inputValidation: {
        requiredAccount: "请选择账号",
        requiredRegion: "请选择区域",
      }
    }
  },

  satisfaction: {
    // 满意度
    title: "满意度",
    search: "查询",
    ticketID: "案例ID",
    summary: "概要",
    initiator: "发起人",
    ticketCategory: "问题类型",
    functionCategory: "功能类型",
    priority: "优先级",
    status: "状态",
    finishTime: "结束时间",
    satisfaction: "满意度",
    operation: "操作",
    detail: "详情",
    comment: "评论",
    searchBySubject: "请输入主题",
    searchByPriority: "请选择优先级",
    pleaseSelectStartTime: "请选择开始时间",
    pleaseSelectEndTime: "请选择结束时间"
  },
  //KPI
  KPI: {
    viewProcessingDetails: "查看处理详情",
    viewSlaDetails: "查看SLA详情",
    pleaseSelectCompany: "请选择公司",
    pleaseSelectOperation: "请选择运维",
    pleaseSelectDate: "请选择日期",
    pleaseSelectType: '请选择值班类型',
    id: "序号",
    ticketEntityId: "案例ID",
    subject: "主题",
    priorityName: "优先级",
    statusName: "状态",
    problemType: "问题类型",
    slaStandard: "标准SLA",
    waitTime: "响应时间(min)",
    name: "姓名",
    total: "总计",
    p1event: "p1事件",
    p2event: "p2事件",
    p3event: "p3事件",
    p4event: "p4事件",
    closed: "已关闭",
    pending: "待处理",
    responseTime: "响应时间",
    processing: "正在处理",
    totalEvent: "事件总数",
    fundamentalStructureAlert: "基础架构告警事件",
    securityAlert: "安全告警事件",
    billingAlert: "账单告警事件",
    companyContribution: "公司贡献",
    changingRequest: "变更请求",
    scheduledTaskManagement: "定时任务管理",
    serviceRequest: "服务申请",
    eventCategory: "问题类型",
    whetherManual: "是否自动",
    automaticallyEstablish: "自动创建",
    manuallyEstablish: "手工创建",
    eventChangingTrendingStatistic: "事件变化趋势统计图",
    casesSLAStatistic: "各级别案例SLA分析统计图",
    casesStatistic: "案例统计",
    nightFactor: "夜班系数",
    documentationContribution: "文档贡献",
    internalContribution: "内部贡献",
    unsatisfiedSLACasesStatistic: "不满足SLA案例统计",
    ticketCategoryName: "种类",
    caseSLAAtEachLevel: "各级别案例SLA",
    dayShift: "白班",
    nightShift: "夜班"
  },
  RedshiftMonitor: {
    //数据仓库
    redshift: "数据仓库",
    addRedshift: "添加数据仓库报警规则",
    cluster: "集群",
    accountName: "账户名称",
    accountType: "账户类别",
    status: "状态",
    region: "区域",
    operation: "操作",
    redshiftList: "数据仓库列表",
    redshiftInfo: "数据仓库信息",
    redshiftDescription: "数据仓库描述",
    redshiftConfig: "数据仓库配置",
    name: "名称",
    // 折线图
    line:{
      PercentageOfUsedDiskSpacePercentage:'已使用磁盘空间的百分比（%）',
      PercentageOfUsedDiskSpace:'已使用磁盘空间的百分比',
      HealthStatus:'健康状态',
      MaintenanceMode:'维护模式',
      ClusterCPUUsagePercentage:'集群CPU使用率(%)',
      ClusterCPUUsage:'集群CPU使用率',
      NumberOfClusterConnectionstimessecond:'集群连接数(次数/秒)',
      NumberOfClusterConnections:'集群连接数',
      ClusterReadAndWriteIOPStimessecond:'集群读写IOPS (次数/秒)',
      ClusterReadIOPS:'集群读IOPS',
      ClusterWriteIOPS:'集群写IOPS'
    }
  },
  DocDBMonitor: {
    //数据仓库
    redshift: "DocDB",
    addRedshift: "添加DocDB报警规则",
    editRedshift:'编辑DocDB报警规则',
    cluster: "集群",
    accountName: "账户名称",
    accountType: "账户类别",
    status: "状态",
    region: "区域",
    operation: "操作",
    redshiftList: "DocDB列表",
    redshiftInfo: "DocDB信息",
    redshiftDescription: "DocDB描述",
    redshiftConfig: "DocDB配置",
    name: "名称",
    ClusterIdentifier:'集群标识符',
    instanceIdentifier:'实例标识符',
    Identifier:'标识符',
    role:'角色',
    EngineVersion:'引擎版本',
    AreasAndZones:'区域和可用区',
    status:'状态',
    size:'大小',
    accountTypes:'账号类型',
    accountName:'账号名称',
    dbClusterMembers:'实例个数',
    roleName:'角色名称',

    clusterCreateTime:'创建时间',
    engineVersion:'引擎版本',
    // 折线图
    line:{
      PercentageOfUsedDiskSpacePercentage:'已使用磁盘空间的百分比（%）',
      PercentageOfUsedDiskSpace:'已使用磁盘空间的百分比',
      HealthStatus:'健康状态',
      MaintenanceMode:'维护模式',
      ClusterCPUUsagePercentage:'集群CPU使用率(%)',
      ClusterCPUUsage:'集群CPU使用率',
      NumberOfClusterConnectionstimessecond:'集群连接数(次数/秒)',
      NumberOfClusterConnections:'集群连接数',
      ClusterReadAndWriteIOPStimessecond:'集群读写IOPS (次数/秒)',
      ClusterReadIOPS:'集群读IOPS',
      ClusterWriteIOPS:'集群写IOPS'
    }
  },
  ElasticSearch: {
    //ElasticSearch
    esDomain: "ES域名",
    accountName: "账户名称",
    accountType: "账户类型",
    region: "区域",
    operation: "操作",
    esList: "ElasticSearch列表",
    addEs: "添加ElasticSearch报警规则",
    EsDescription: "ElasticSearch描述",
    EsConfig: "ElasticSearch 配置",
    EsInfo: "ElasticSearch 信息",
    name: "名称",
    // 折线图
    line:{
      ClusterAverageCPUUtilizationPercentage:'集群平均CPU利用率（百分比）',
      ClusterAverageCPUUtilization:'集群平均CPU利用率',
      ClusterStatus:'集群状态',
      ClusterStatusRed:'集群状态(红色)',
      ClusterStatusYellow:'集群状态(黄色)',
      ESClusterStatusRed:'红色集群状态',
      ESClusterStatusYellow:'黄色集群状态',
      ESFreeStorageSpace:'集群可用存储空间',
      ESClusterIndexWritesBlocked:'集群正在阻止写入请求',
      ESNodes:'集群节点',
      ESAutomatedSnapshotFailure:'自动快照失败',
      ESCPUUtilization:'CPU使用率',
      ESJVMMemoryPressure:'集群中所有数据节点的 Java 堆的最大百分比',
      ESMasterCPUUtilization:'主节点CPU使用率',
      ESMasterJVMMemoryPressure:'集群中主数据节点的 Java 堆的最大百分比',
      ESKMSKeyError:'域中加密静态数据的 KMS 加密密钥已禁用',
      ESKMSKeyInaccessible:'域中加密静态数据的 KMS 加密密钥已被删除或已撤销其对 Amazon ES 的授权',
    }
  },
  StorageGateway: {
    //StorageGateway
    accountName: "账户名称",
    accountType: "账户类型",
    region: "区域",
    name: "名称",
    // 折线图
    line:{
      cachePercentUsed:'缓存总使用率 (百分比)',
      cacheHitPercent:'缓存命中率（百分比）',
      ioWaitPercent:'高 IO 等待（百分比）',
      availabilityNotifications:'可用性通知',
      healthNotifications:'运行状况通知',
      cachePercentDirty:'缓存脏数据（百分比）'
    }
  },
  application: {
    //应用
    alertRule: "报警规则",
    ruleName: "规则名称",
    status: "状态",
    monitorIndex: "监控指标",
    indexDescription: "指标描述",
    contact: "通知对象",
    category: "类型",
    instanceList: "实例列表",
    name: "名称",
    accountName: "账户名称",
    accountType: "账户类型",
    instanceID: "实例ID"
  },
  ActionTrailSecurity: {
    //安全ActionTrail
    title: "安全（ActionTrail）",
    chinaRegion: "中国区",
    account: "账户",
    time: "时间",
    region: "区域",
    eventName: "事件名称",
    eventType: "事件类型",
    userName: "用户名",
    resourceType: "资源类型",
    resourceName: "资源名称",
    errorCode: "错误码",
    accountName: "账号名称",
    eventTime: "事件时间",
    search: "搜索",
    area:'地区',
    AccessKey:"访问秘钥",
    EventSource:"事件源",
    district:"地域",
    ErrorCode:"错误代码",
    RequestID:"请求ID",
    EventID:"事件ID",
    SourceIPAddress:"源IP地址",
    EventName:"事件名称",
    RelatedResources:"相关资源",
    pleaseSelectEventName: "请选择事件名称"
  },
  CloudTrailSecurity: {
    //安全CloudTrail
    title: "安全（CloudTrail）",
    alertRule: "报警规则",
    ruleName: "规则名称",
    status: "状态",
    monitorIndex: "监控指标",
    contact: "通知对象",
    category: "类型",
    operation: "操作",
    cloudTrailLogList: "CloudTrail日志列表",
    account: "账户",
    region: "区域",
    time: "时间",
    caseName: "事件名称",
    caseTime: "事件时间",
    resourceType: "资源类型",
    resourceName: "资源名称",
    addCloudTrailSecurityAlertRule: "添加安全CloudTrail报警规则",
    operationLog: "操作日志",
    search: "搜索",
    userName: "用户名",
    accessKeyId:"AWS访问秘钥",
    awsRegion:"AWS地域",
    readOnly:"只读",
    errorCode:"错误代码",
    requestId:"请求ID",
    eventId:"事件ID",
    invokedBy:"源IP地址",
    eventSource:"事件源"
  },
  TrustAdvisor: {
    consultant: '顾问列表',
    alertRule: "报警规则",
    ruleName: "规则名称",
    status: "状态",
    monitorIndex: "监控指标",
    contact: "通知对象",
    category: "类型",
    operation: "操作",
    highAvailability: "高可用性",
    suggestion: "建议",
    greatestInfluence: "影响最大",
    mediumInfluence: "中等程度的影响",
    lowestInfluence: "最小影响",
    influencedResources: "受影响的资源",
    security: "安全性",
    performance: "性能",
    cost: "成本",
    alertDelay: "延迟告警",
    overview: "概览",
    addTrustAdvisorAlert: "添加Advisor报警规则",
    updateTrustAdvisorAlert: "编辑Advisor报警规则",
    detail: "详情",
    generalSuggestion: "总体建议",
    influence: "影响",
    explanation: "说明",
    updateTime: "更新时间",
    sortedSuggestion: "按影响排列的建议"
  },
  ARD: {
    //AffectResourceDetail
    region: "区域",
    IPAddress: "IP地址",
    regionAZ: "区域AZ",
    volumeID: "卷ID",
    volumeName: "卷名",
    volumeAttachment: "卷附加",
    instanceID: "实例ID",
    instanceType: "实例类型",
    instanceName: "实例名称",
    ebsOptimize: "ebs优化",
    status: "状态",
    snapshotID: "快照ID",
    snapshotName: "快照名称",
    snapshotAge: "快照年龄",
    reason: "原因",
    AZ: "AZ",
    dbInstance: "数据库实例",
    backupRetentionPeriod: "备份保留期",
    bucketName: "存储桶名称",
    tgtName: "目标名称",
    tgtExist: "目标存在",
    sameOwner: "所有者相同",
    writeEnable: "写权限已启用",
    regionName: "区域名称",
    regionAPIParameter: "区域 API 参数",
    ACLAllowList: "ACL 允许列表",
    ACLAllowUploadDelete: "ACL 允许上传/删除",
    policyAllowAccess: "策略允许访问",
    ignoredBucketName: "已忽略的存储桶名称",
    ASGroupName: "AutoScaling 组名称",
    loadBalancerAssociated: "关联的负载均衡器",
    healthCheck: "运行状况检查",
    launchConfigName: "启动配置名称",
    launchName: "启动名称",
    launchType: "启动类型",
    resourceName: "资源名",
    resourceType: "资源类型",
    securityGroupName: "安全组名称",
    securityGroupID: "Security Group ID",
    groupID: "组ID",
    description: "描述",
    instanceAmount: "实例数量",
    totalInboudRules: "全部入站规则",
    totalOutboudRules: "全部出站规则",
    loadBalancerName: "负载均衡器名称",
    loadBalancerPort: "负载均衡器端口",
    passwordPolicy: "密码策略",
    upperCase: "大写",
    lowerCase: "小写",
    number: "数字",
    nonAlphanumeric: "非字母数字",
    protocol: "协议",
    port: "端口",
    ipRange: "IP 范围",
    zoneAmount: "区域数量",
    ZoneAInstance: "A 区实例",
    ZoneBInstance: "B 区实例",
    ZoneCInstance: "C 区实例",
    ZoneDInstance: "D 区实例",
    ZoneEInstance: "E 区实例",
    ZoneFInstance: "F 区实例",
    day1: "Day 1",
    day2: "Day 2",
    day3: "Day 3",
    day4: "Day 4",
    day5: "Day 5",
    day6: "Day 6",
    day7: "Day 7",
    day8: "Day 8",
    day9: "Day 9",
    day10: "Day 10",
    day11: "Day 11",
    day12: "Day 12",
    day13: "Day 13",
    day14: "Day 14",
    day14avgCPUUtlz: "14天CPU平均使用率",
    amtDaysCPUUtlzOver90: "CPU使用率超过90%的天数",
    amountOfDaysOver: "超过的天数",
    maxDailyMedian: "最大每日中值",
    estimateMonthlySaving: "预计每月节省"
  },
  //账单
  Bill: {
    //RI页面
    RI: {
      title: "RI页面",
      currentRIList: "当前预留实例列表",
      reservedInstanceReccmd: "预留实例推荐",
      otherReservedList: "当前预留RDS,预留ElastiCache,预留Redshift,预留ElastiSearch等列表",
      DHHostReservedInstance: "DH Host预留实例",
      proEnvInstanceStatus: "生产环境实例情况 (以上取数为前日01:00pm至昨日01:00pm)",
      devEnvInstanceStatus: "开发环境实例情况 (以上取数为前日01:00pm至昨日01:00pm)",
      system: "系统",
      quantity: "数量/单元",
      startTime: "开始时间",
      endTime: "截止时间 ",
      rent: "租赁",
      RIRecAmount: "RI推荐数量",
      account: "账号",
      subScriptionId: "订阅ID",
      due: "到期(天)",
      series: "系列",
      instanceAmount: "实例数量/单元",
      RIAmount: "RI数量",
      detail: "具体数据",
      beijing: "北京",
      Singapore: "新加坡"
    },
    // 账单页面
    Billing: {
      title: "账单页面",
      recent10DaysAnalysis: "近10日各服务每日花费分析",
      monthlyCost: "月度花费",
      dailyCostCurve: "花费日增长曲线",
      eachDimentionCost: "花费日增长曲线",
      unit: "(单位:",
      S3: "对象存储 (单位:GB)",
      serviceName: "服务",
      linkedaccountid: "账号",
      selectAll: '全选',
      billingday: "日期",
      region: "区域",
      servicename: "服务",
      unblendedcosUnit: "花费",
      export: "导出",
      beforeDiscount: "折扣前",
      afterDiscount: "折扣后",
      month: "月度",
      theProportionOfEachDimension: "各维度花费比例",
      dimenkey: "键",
      keyvalue: "键值",
      detail: "具体数据",
      resourceId: "资源ID",
      usageDate: "使用时间",
      usageQuantity: "使用量",
      totalCost: "总和花费"
    },
    // AWS账单页面
    SLBilling: {
      resourceCategories:'Top 15 资源类别',
      title: "AWS账单页面",
      monthPrediction: "预测",
      monthBilling: "账单",
      monthlyBillingAmount: "每月账单金额",
      billingOverview: "账单概览",
      billAmount: "账单金额",
      Histogram:"矩形图",
      total:"总量"
    },
    CostAllocation: {
      title: "成本分摊",
      tableName: "表名",
      applicationName: "应用名",
      costCenter: "成本中心",
      name: "名称",
      proportionOfContribution: "分摊比例(%)",
      timer: "开始时间-结束时间",
      batchExport: "批量导出"
    },
    ResourceOptimization: {
      title: "资源优化",
      pleaseSelectProjectValue: "请选择project值",
      RIDataSource: "RI数据源",
      prompt: "提示",
      singleAvailabilityStandardizedUnit: "单可用区标准化单位",
      multiAvailabilityStandardizedUnit: "多可用区标准化单位",
      pleaseSelectLabelValue: "请选择标签值",
      pleaseSelectAccount: "请选择账号",
      customer: "客户",
      engineType: "引擎类型",
      instanceType: "实例类型",
      elasticsearchCount: "Elasticsearch量(实时数量)",
      RIRecommendedQuantity: "RI 推荐数量",
      RIAvailableQuantity: "现有RI数量",
      purchaseRate: "购买率",
      exactlyMatchTheSavings: "完全匹配节省费用",
      currentlyReservedToSaveCosts: "当前预留节省费用",
      toolTips: "所有预留实例相关费用均以 All Upfront 计费方式计算",
      os: '操作系统',
      EC2Count: "EC2量(实时数量)",
      clientCompany: "客户公司",
      specialDiscountOrNot: "是否特殊折扣",
      CUDRecommendationPage: "CUD推荐页面",
      recommendedPurchaseCUDNumber: "建议购买CUD数",
      purchasedCUDNumber: "已经购买CUD数",
      noMatchCUD: "本月未匹配CUD平均数量",
      nextMonthCUD: "下月推荐购买CUD后节省费用",
      CUDUsage: "CUD使用情况",
      utilizationRate: "利用率",
      queryInterval: "请输入查询区间",
      coverageRate: "覆盖率",
      payAccount: "请选择付款账号"
    },
    CostCalculation: {
      title: "成本计算",
      reset: "重置",
      EC2: "EC2 (服务器实例)",
      storage: "存储",
      RDS: "RDS (关系型数据库)",
      subtotal: "小计",
      AWSTotal: "AWS总计",
      purpose: "用途",
      region: "地区",
      cache: "内存",
      OS: "操作系统",
      paymentMethod: "付费类型",
      amount: "数量",
      unitPrice: "单价",
      month: "月",
      price: "价格",
      operation: "操作",
      storageType: "存储类型",
      serviceType: "服务类型",
      storageCapacity: "存储容量",
      preConfigIOPS: "预配置的IOPS数量",
      databaseType: "数据库类型",
      deploymentMethod: "部署方式",
      year: "年",
    },
    ebilling:{
      dashboard:"仪表盘",
      account:"账户",
      tag:"标签",
      service:"服务",
      LicenseRI:"License RI",
      NolicenceRI:"Nolicence RI",
      region:"区域",
      custom:"客户自定义",
      bill:"账单",
      awsBill:"AWS账单"
    },

  },
  companyManagement: {
    //公司管理
    title: "公司管理",
    companyName: "公司名称",
    companyAddress: "公司地址",
    parentCompanyName: "母公司名称",
    emailNotificationReply: "邮件通知回复案例",
    AWSHealthMonitorDashboard: "AWS健康监控仪表盘",
    billingAddress: "账单邮寄地址",
    customerType: "客户类型",
    operation: "操作",
    addCompany: "添加公司",
    yes: "是",
    no: "否",
  },
  RIAccountGroupManagement: {
    //财务账户组管理
    title: "财务账户组管理",
    RIAccountGroupName: "财务账户组名称",
    addRIAccountGroup: "添加财务账户组",
    editRIAccountGroup: "编辑财务账户组",
    configuration: "配置",
    region: "地区",
    area: "地区",
    AvailabilityZone: "区域",
    AZ: "区域",
    comment: "备注",
    operation: "操作",
    RIAccountGroupConfig: "财务账户组配置",
    accountName: "账户名",
    accountID: "账户ID",
    addAccount: "添加账户",
    companyName: "公司名称",
    cancel: "取消",
    China:"中国",
    Overseas:"海外",
    Native:"原生",
    queryByAccountGroupName: '请输入财务账户组名称',
    accountGroupNameNotEmpty: '账户组名称不能为空',
    accountGroupNameValidateMsg: '账户组名称为4-20个字符',
    pleaseSelectArea: '请选择地区',
    pleaseSelectRegion: '请选择区域'
  },


  MenuManagement: {
    //菜单管理
    menuManagement: "菜单管理",
    addMenu: "添加菜单",
    menuName: "菜单名称",
    category: "类型",
    sort: "排序",
    menuIcon: "菜单图标",
    permissionIcon: "权限标识",
    addressPath: "地址栏路径",
    componentPath: "组件路径",
    operation: "操作",
    edit: "编辑",
    delete: "删除",
    editMenu: '编辑菜单',
    upperMenu: '上级菜单',
    buttonName: '按钮名称',
    menuTitle: '菜单标题',
    englishTitle: '英文标题',
    directory: '目录',
    menu: '菜单',
    button: '按钮',
    pleaseSelectType: '请选择类型',
    pleaseInputMenuTitle: '请输入菜单标题',
    pleaseInputEnglishTitle: '请输入英文标题',
    pleaseInputSort: '请输入排序',
    pleaseInputAddressPath: '请输入地址栏路径',
    pleaseInputComponentPath: '请输入组件路径',
    pleaseInputMenuIcon: '请输入菜单图标',
    pleaseInputButtonName: '请输入按钮名称',
    pleaseInputPermissionIcon:'请输入权限标识'
  },
  AWSBilling: {
    //AWS账单页面
    prediction: "预测",
    billings: "账单",
    monthlyBillingCost: "每月账单金额",
    billingPreview: "账单预览",
    top15ResourceType: "Top15资源类型"
  },
  cudrecommendation:{
    //CUD推荐页面
    commitmentId:"CUD ID",
    name:"名称",
    start:"起始时间",
    end:"截止时间",
    autoRenew:"自动续订",
    typeName:"类型",
    statusName:"状态",
    planName:"时长",
    search:"搜索",

   }, cudRecommendForm:{
      companyId:"请选择公司",
      accountId:"请选择账号",
      cudType:"请选择机型",
      availableArea:"请选择可用区",
      resourceType:"请选择资源类型",
    },
    //预留实例
    reservedInstance:{
      //覆盖率报告
      coverage:{
        pleaseSelect:"请选择查询区间",
        customer: "客户",
        accountName:"账户名称",
        accountId:"账户ID",
        EC2:"EC2",
        RDS:"RDS",
        Redshift:"Redshift",
        ElastiCache:"ElastiCache",
        Opensearch:"Opensearch"
      },
    },
  // PatchEasy
  PatchEasy: {
    // 补丁策略
    PatchPolicy: {
      title: "补丁策略",
      addStrategy: "添加策略",
      name: "名称",
      policyName: "策略名称",
      account: "账户",
      dispatchDuty: "调度任务",
      config: "配置",
      patchstdConfig: "补丁标准配置",
      patchcmdPara: "补丁命令参数",
      deleteStrategy: "删除策略",
      instantRun: "立即运行",
      addStdConfig: "添加标准配置",
      stdID: "基准ID",
      stdName: "基准名称",
      description: "描述",
      OS: "操作系统",
      defaultStd: "默认基准",
      productSeries: "产品系列",
      product: "产品",
      category: "分类",
      severityLevel: "严重级别"
    },
    //命令列表
    PatchCmd: {
      title: "命令列表",
      cmdID: "命令 ID",
      requestDate: "请求日期",
      fileName: "文档名称",
      comment: "注释",
      tgt: "# 目标",
      error: "# 错误",
      submitDelay: "# 提交超时",
      complete: "# 完成",
      search: "搜索",
      command: "命令",
      commandHistory: "命令历史记录",
      account: "账号",
      region: "区域",
      selectByAccount: "请输入账号",
      selectByRegion: "请输入区域",
      selectByCmdID: "请输入命令ID",
      commandDetails: "命令详情",
      commandStatus: "命令状态",
      overallStatus: "总体状态",
      detailedStatus: "详细状态",
      goalsAndOutputs: "目标与输出",
      selectByInstanceID: "请输入实例ID",
      instanceID: "实例 ID",
      instanceName: "实例名称",
      backupID: "备份ID",
      startTime: "开始时间",
      completeTime: "完成时间",
      viewOutput: "查看输出",
      output: "输出",
      descriptionAndStatus: "步骤 1 - 命令描述和状态",
      responseCode: "响应代码",
      stepName: "步骤名称",
      stepOneOutput: "步骤 1 - 输出",
      tip: "命令输出最多显示 2500 个字符。如果您在运行命令时指定了 S3 存储桶或 CloudWatch 日志组，则可以在 Amazon S3 或 CloudWatch 日志中查看完整的命令输出。",
      nameAndDescription: "名称和描述",
      commandDocument: "命令文档",
      documentVersion: "文档版本",
      requestTime: "请求时间",
      commandParameters: "命令参数",
      parameter: "参数",
      deliveryTimeout: "交付超时 (秒)",
      executionTimeout: "执行超时 (秒)"
    }
  },
  //资源配置管理
  RAM: {
    AWS: {
      computeInstance: {
        //计算实例
        title: "计算实例",
        accountID: "账户ID",
        accountName: "账户名称",
        region: "区域",
        instanceName: "实例名称",
        instanceID: "实例ID",
        instanceType: "实例类型",
        CPU:"CPU",
        AMIID:"AMI ID",
        VPCID:"VPC ID",
        EBSDevices:"EBS Devices",
        cache: "内存（GB）",
        diskStorage: "储存大小（GB）",
        T2T3Unlimited:"T2/T3无限",
        OperatingSystem:"操作系统",
        stateName:"状态名称",
        InstanceStatus:"实例状态",
        Project:"项目",
        Owner:"拥有者",
        SystemHealthStatus:"系统健康状态",
        InstanceHealthStatus:"实例健康状态",
        PublicIP:"公有IP",
        PrivateIP:"私有IP",
        SubnetID:"子网ID",
        CreationTime:"创建时间",
        SecurityGroupID:"安全组ID",
        SecurityGroupName:"安全组名称"
      },
      eks:{
        title:"EKS",
        name:"集群名称",
        version:"集群版本号",
        status:"集群状态",
        platformVersion:"平台版本号",
        createdAt:"集群的创建时间",
        endpoint:"终端节点",
        pointName:"节点组名称",
        releaseVersion:"AMI 发行版本",
        minSize:"最大大小",
        maxSize:"最小大小",
        amiType:"AMI 类型",
        diskSize:"磁盘大小"
      },
      emr:{
        title:"EMR",
        clusterId:"集群ID",
        name:"集群名称",
        status:"集群状态",
        logUrl:"日志URI",
        releaseLabel:"发行版标签",
        normalizedInstanceHours:"标准实例小时数",
        masterPublicDnsName:"主节点公有DNS",
        clusterArn:"集群ARN",
        creationDate:"集群创建时间",
      },
      tgw:{
        //tgw
        title:"TGW",
        name:"中转网关名称",
        transitGatewayId:"中转网关ID",
        description:"描述",
        ownerId:"拥有者ID",
        state:"状态",
        associationDefaultRouteTableId:"关联路由表ID",
        propagationDefaultRouteTableId:"传播路由表ID",
        creationTime:"创建时间",
        amazonSideAsn:"Amazon ASN",
        dnsSupport:"DNS 支持",
        vpnEcmpSupport:"VPN ECMP 支持",
        autoAcceptSharedAttachments:"自动接受共享挂载",
        defaultRouteTableAssociation:"原定设置关联路由表",
        multicastSupport:"多播支持",
        defaultRouteTablePropagation:"原定设置传播路由表",
        transitGatewayAttachmentId:"中转网关挂载ID",
        resourceType:"资源类型",
        resourceId:"资源ID",
        transitGatewaystate:"挂载状态",
        transitGatewayRouteTableId:"挂载关联路由表ID",
        associationState:"关联状态"
      },
      DedicatedHosting:{
      //专用主机
      title: "专用主机",
      accountID: "账户ID",
      accountName: "账户名称",
      region: "区域",
      name:"主机名称",
      hostId:"主机ID",
      availabilityZone:"可用区",
      state:"状态",
      instanceFamily:"实例系列",
      instanceType:"实例类型",
      },
      database: {
        //数据库
        title: "数据库",
        accountName: "账户名称",
        accountID: "账户ID",
        instanceName: "实例名称",
        terminalNode: "终端节点",
        engine: "引擎",
        instanceType: "实例类型",
        storageSize: "储存大小(G)",
        multipleAZ: "多可用区",
        maintenance: "维护",
        subnetGroup: "子网组",
        runningStatus: "运行状态",
        launchTime: "创建时间",
        backupPolicy: "备份策略",
        subnetID: "子网ID",
        region: "区域",
        iops: "IOPS",
      },
      VirtualNetwork: {
        //虚拟网络
        title: "虚拟网络",
        accountName: "账户名称",
        accountID: "账户ID",
        VPCName: "VPC名称",
        DHCPSettingSet: "DHCP选项集",
        routeTableId:"主路由表",
        defaultVPC: "默认VPC",
        runningStatus: "运行状态"
      },
      Elasticsearch: {
        //Elasticsearch
        region: "地区",
        title: "Elasticsearch",
        accountName: "账户名称",
        accountID: "账户ID",
        domainName: "域",
        elasticsearchVersion: "Elasticsearch 版本",
        volumeType: "卷类型",
        volumeSize: "卷大小",
        instanceType: "实例类型（数据）",
        instanceCount: "节点数",
        dedicatedMasterType: "实例类型（主实例）",
        dedicatedMasterCount: "主实例数"
      },
      ElasticBlockStorage: {
        //弹性快存储
        title: "弹性快存储",
        accountName: "账户名称",
        accountID: "账户ID",
        volumeName: "卷名称",
        volumeID: "卷id",
        volumeCapacity: "卷大小",
        volumeCategory: "卷类型",
        attachedStatus: "关联状态",
        attachedInstanceID: "关联实例ID"
      },
      ElasticLoadBalancer: {
        //弹性负载均衡
        title: "弹性负载均衡",
        accountName: "账户名称",
        accountID: "账户ID",
        ELBName: "ELB名称",
        DNSName: "DNS名称",
        availabilityZone: "可用区",
        instanceID: "实例ID",
        targetCluster: "目标群组",
        securityGroup: "安全组",
        pleaseEnterELBName: "请输入负载均衡名称"
      },
      StorageBin: {
        //储存桶
        title: "储存桶",
        accountName: "账户名称",
        accountID: "账户ID",
        binName: "桶名称",
        bucketStorage:"桶容量(GB)",
        launchTime: "创建时间",
        establishPerson: "创建人",
        bucketLogging: "是否开启访问日志",
        bucketLoggingUrl: "访问日志路径",
        binAuthorization: "桶权限",
        encryption: "加密",
        public: "公开",
        lifeCycle: "生命周期"
      },
      Redshift: {
        accountName: "账户名称",
        accountID: "账户ID",
        clusterName: "集群名称",
        clusterStatus: "集群状态",
        databaseStatus: "数据库状态",
        releaseStatus: "发行状态",
        maintain: "是否维护",
        nodeType: "节点类型",
        region: "区域",
        clusterSubnetGroup: "集群子网组",
        recentEventsAmount: "最近事件数",
        nodesAmount: "节点数",
        clusterParametersGroup: "集群参数组",
        subnet: "子网"
      },
      ElasticCache: {
        //弹性缓存
        memcachedTitle: "Memcached",
        redisTitle: "Redis",
        accountName: "账户名称",
        accountID: "账户ID",
        region: "区域",
        clusterName: "集群名称",
        statusName: "状态",
        createdTime: "创建时间",
        primaryEndpoint: "主终端节点",
        configurationEndpoint: "配置终端节点",
        engine: "引擎",
        nodeType: "节点类型",
        slice: "分片",
        nodesAmount: "节点个数",
        multiAz: "多可用区",
        securityGroups: "安全组",
        NodeID:"节点ID",
        TerminalNode:"终端节点",
        Port:"端口",
        AvailabilityZone:"可用区",
        CurrentRole:"当前角色"
      },
      RI: {
        //预留实例
        EC2: {
          accountName: "账户名称",
          accountID: "账户ID",
          region: "区域",
          instanceType: "实例类型",
          start: "启动",
          overdue: "过期",
          due: "期限",
          paymentMethod: "付款方式",
          providedType: "提供的类型",
          platform: "平台",
          status: "状态",
          rentTime: "租期",
          instanceAmount: "实例数量",
          standardizeFactor: "标准化因子"
        },
        RDS: {
          accountName: "账户名称",
          accountID: "账户ID",
          region: "区域",
          reservedInstanceID: "预留实例ID",
          engine: "引擎",
          instanceType: "实例类型",
          paymentMethod: "付款方式",
          status: "状态",
          start: "启动",
          overdue: "过期",
          due: "期限",
          multipleAvailabilityZone: "多可用区",
          amount: "数量",
          standardizeFactor: "标准化因子"
        },
        ElasticCache: {
          accountName: "账户名称",
          accountID: "账户ID",
          region: "区域",
          reservedCacheNodeID: "预留缓存节点ID",
          productDescription: "产品描述",
          CacheNodeType: "缓存节点类型",
          productType: "产品类型",
          status: "状态",
          start: "启动",
          overdue: "过期",
          nodeAmount: "节点数量",
          due: "期限"
        },
        RedShift: {
          accountName: "账户名称",
          accountID: "账户ID",
          region: "区域",
          reservedNodeID: "预留节点ID",
          NodeType: "节点类型",
          productType: "产品类型",
          status: "状态",
          start: "启动",
          overdue: "过期",
          due: "期限",
          amount: "数量"
        },
        ElasticSearch: {
          name: "名称",
          id: "预留实例ID",
          accountName: "账户名称",
          accountID: "账户ID",
          region: "区域",
          reservedCacheNodeID: "预留缓存节点ID",
          productDescription: "产品描述",
          CacheNodeType: "实例类型",
          productType: "产品类型",
          status: "状态",
          start: "启动",
          overdue: "过期",
          nodeNumber: "节点数量",
          due: "期限"
        }
      },
      ElasticIP: {
        //弹性IP
        title: "弹性IP",
        accountName: "账户名称",
        accountID: "账户ID",
        ElasticIP: "弹性IP",
        allocatedID: "分配ID",
        privateIP: "私有IP",
        AttachedInstance: "关联实例"
      },
      routingTable: {
        //路由表
        title: "路由表",
        accountName: "账户名称",
        accountID: "账户ID",
        routingTableName: "路由表名称",
        routingTableID: "路由表ID",
        isMainRoutingTable: "是否是主路由表",
        ipAddress:"ip地址",
        instanceId:"指定实例id",
        gatewayId:"指定网关id",
        routeState:"路由状态"

      },
      Gateway: {
        //网关
        title: "网关",
        accountName: "账户名称",
        accountID: "账户ID",
        gatewayName: "网关名称",
        gatewayID: "网关ID"
      },
      Subnet: {
        //子网
        title: "子网",
        accountName: "账户名称",
        accountID: "账户ID",
        subnetName: "子网名称",
        subnetID: "子网ID",
        availabilityZone: "可用区",
        availableIP: "可用IP数"
      },
      SecurityGroup: {
        //安全组
        title: "安全组",
        accountName: "账户名称",
        accountID: "账户ID",
        securityGroupName: "安全组名称",
        securityGroupID: "安全组ID",
        protocolType: "协议类型",
        protocol: "协议",
        port: "端口",
        resource: "资源",
        accessRules: "类型"
      },
      Event: {
        // 事件
        title: "事件变更记录",
        accountName: "账号名称",
        accountID: "账号ID",
        region: "区域",
        resource: "资源",
        resourceId: "资源ID",
        instanceType: "实例类型",
        eventType: "事件类型",
        beforeChangeStatus: "变更前状态",
        afterChangeStatus: "变更后状态",
        eventTime: "事件时间"
      },
      IdentityAndAccessManagement: {
        //身份和访问管理
        title: "用户",
        accountName: "账户名称",
        accountID: "账户ID",
        userName: "用户名",
        group: "组",
        accessKeyAge: "访问密钥使用期限",
        passwordAge: "密码使用期限",
        lastActivity: "上一次活动",
        mfa: "MFA",
        policyName: "策略名称",
        policyTypeName: "策略类型",
        policyFrom: "策略附加"
      },
      IAM:{
        Group:{
          // 组
          title:"组",
          AccountName:"账户名称",
          AccountId:"账户Id",
          GroupName:"组名",
          NumberOfPeople:"人数",
          PolicyType:"策略类型",
          PolicyName:"策略名称",
          pleaseEnterGroupName: "请输入组名",
          pleaseEnterPolicyName: "请输入策略名称"
        },
        Policy:{
          // 策略
          title:"策略",
          AccountName:"账户名称",
          AccountId:"账户Id",
          PolicyName:"策略名称",
          PolicyType:"策略类型"
        },
        AKSK: {
          pleaseEnterIamUserName: "请输入AKSK用户名称"
        }
      },
      Backup:{
        Repository:{
          title:"备份保管库",
          backupVaultName:"备份保管库名称",
          numberOfRecoveryPoints:"恢复点",
          encryptionKeyArn:"KMS 加密密钥 ID",
          creationDate:"创建日期",
          recoveryPointArn:"恢复点ID",
          status:"状态",
          resourceArn:"资源ID",
          resourceType:"资源类型",
          deleteAfterDaysDesc:"保留期",
          moveToColdStorageAfterDaysDesc:"转为冷存储",
        },
        Plan:{
          title:"备份计划",
          backupPlanId:"备份计划ID",
          backupPlanName:"备份计划名称",
          lastExecutionDate:"上次运行时",
          creationDate:"上次修改时间",
          ruleName:"名称",
          targetBackupVaultName:"备份保管库",
          destinationBackupVaultArn:"目标备份保管库",
          selectionName:"名称",
          iamRoleArn:"IAM角色ARN",
          creationDate:"创建时间",
          backupPlanRule:"备份规则",
          resourceAllocation:"资源分配"
        }
      },
      DynamoDB: {
        partitionKey: '分区键',
        sortKey: '排序键',
        index: '索引',
        deleteProtection: '删除保护',
        readCapacity: '读取容量',
        readCapacityMode: '读取容量模式',
        writeCapacity: '写入容量',
        writeCapacityMode: '写入容量模式',
        totalSize: '总大小',
        listClass: '表类',
        projectionAttribute: '投影属性',
        numberOfEntries: '项目数'
      },
      ECR: {
        title: '弹性容器注册表',
        repositoryName: '存储库名称',
        enterRepositoryName: '请输入存储库名称',
        labelInvariance: '标签不变性',
        pushScan: '推送扫描',
        encryptionType: '加密类型',
        imageTag: '映像标签',
        componentType: '构件类型',
        pushPosition: '推送位置',
        size: '大小',
        imageURI: '映像URI',
        digest: '摘要',
        scanningState: '扫描状态',
        bug: '漏洞'
      },
      ECS: {
        title: '弹性容器服务',
        clusterName: '集群名称',
        enterClusterName: '请输入集群名称',
        service: '服务',
        task: '任务',
        running: '正在运行',
        containerInstance: '容器实例',
        monitoring: 'CloudWatch 监控',
        capacityProviderStrategy: '容量提供商策略',
        clusterDescription: '集群描述',
        serviceName: '服务名称',
        status: '状态',
        serviceType: '服务类型',
        rolloutState: '上次部署',
        taskDefinition: '任务定义',
        launchType: '启动类型',
        lastStatus: '最后状态',
        desiredStatus: '预期状态',
        runningState: '运行状态',
        startTime: '启动时间',
        memory: '内存(GB)',
        updateSuccess: '更新成功',
        pleaseWait: '正在导出，请稍等...',
        exportSuccess: '导出成功'
      },
      KMS: {
        aliases: '别名',
        enterAliases: '请输入密钥别名',
        keyId: '密钥ID',
        status: '状态',
        creationDate: '创建日期',
        dueDate: '到期日期',
        source: '来源',
        keyType: '密钥类型',
        keySpecification: '密钥规格',
        keyUsage: '密钥使用情况'
      },
      DMS: {
        serverlessReplications: '无服务器复制',
        replicationInstances: '复制实例',
        name: '名称',
        type: '类型',
        sourceEndpoint: '源端点',
        targetEndpoint: '目标端点',
        created: '创建时间',
        enterName: '请输入名称',
        class: '类',
        engineVersion: '引擎版本',
        availabilityZone: '可用区',
        publicIPAddress: '公有IP地址',
        privateIPAddress: '私有IP地址',
        multiAZ: '多可用区'
      }
    },
    Azure: {
      VirtualMachine: {
        //虚拟机
        title: "虚拟机",
        accountName: "账户名",
        subscriptionName: "订阅名称",
        subscriptionID: "订阅ID",
        resourceGroup: "资源组",
        instanceName: "实例名称",
        instanceType: "实例类型",
        cache: "内存(GB)",
        diskStorage: "磁盘容量(GB)",
        operatingSystem: "操作系统",
        instanceStatus: "实例状态",
        project: "项目",
        owner: "拥有者",
        publicIP: "公有IP",
        privateIP: "私有IP",
        virtualNetworkAndSubnet: "虚拟网络/子网",
        NetworkSecurityGroup: "网络安全组"
      },
      database: {
        //数据库
        title: "数据库",
        accountName: "账户名称",
        subscriptionName: "订阅名称",
        subscriptionID: "订阅ID",
        resourceGroup: "资源组",
        databaseName: "数据库名称",
        serverName: "服务器名称",
        location: "位置",
        status: "状态",
        connectionString: "连接字符串",
        pricingLevel: "定价层"
      },
      VirtualNetwork: {
        //虚拟网络
        title: "虚拟网络",
        accountName: "账户名称",
        subscriptionName: "订阅名称",
        subscriptionID: "订阅ID",
        resourceGroup: "资源组",
        VPCName: "VPC名称",
        location: "位置",
        addressSpace: "地址空间"
      },
      trusteeDisk: {
        //托管磁盘
        title: "托管磁盘",
        accountName: "账户名称",
        subscriptionName: "订阅名称",
        subscriptionID: "订阅ID",
        resourceGroup: "资源组",
        diskConfig: "磁盘设置",
        status: "状态",
        owner: "所有者",
        operatingSystem: "操作系统",
        launchTime: "创建时间"
      },
      storageAccount: {
        //存储账户
        title: "存储账户",
        storageAccountName: "存储账户名",
        accountName: "账户名称",
        subscriptionName: "订阅名称",
        subscriptionID: "订阅ID",
        resourceGroup: "资源组",
        performance: "性能",
        status: "状态",
        duplicationAndRedundant: "复制/冗余",
        accountType: "账户类型"
      },
      appService:{
        title:"应用程序服务",
        AccountName:"账户名",
        AccountID:"账户ID",
        SubscriptionName:"订阅名称",
        SubscriptionID:"订阅ID",
        ResourceGroup:"资源组",
        Name:"名称",
        Area:"地区",
        Status:"状态",
        Type:"类型",
        ServerFarm:"服务器群"
      },
      loadBalance:{
        title:"负载均衡",
        AccountName:"账户名",
        AccountID:"账户ID",
        SubscriptionID:"订阅ID",
        Name:"名称",
        ResourceGroup:"资源组",
        Area:"地区",
        BackendPool:"后端池",
        HealthDetection:"运行状况探测",
        LoadBalancingRules:"负载均衡规则",
        DedicatedIPAddress:"专用IP地址",
        SKU:"SKU"
      }
    },
    ALI:{
      computeInstance: {
        ackTitle: "Ack(k8s)",
        //计算实例
        title: "计算实例",
        accountID: "账户ID",
        accountName: "账户名称",
        region: "区域",
        instanceName: "实例名称",
        instanceID: "实例ID",
        instanceType: "实例类型",
        cache: "内存（GB）",
        diskStorage: "储存大小（GB）",
        ImageId:"ImageID(镜像ID)",
        amazonVpcId:"VPC ID",
        OperatingSystem:"操作系统",
        InstanceStatus:"实例状态",
        Project:"项目",
        Owner:"拥有者",
        PublicIP:"公有IP",
        PrivateIP:"私有IP",
        InstanceCreatedTime:"创建时间",
      },
      database: {
        //数据库
        title: "数据库",
        accountName: "账户名称",
        accountID: "账户ID",
        engine: "引擎",
        name:"实例名称",
        instanceType: "实例类型",
        storageSize: "储存大小(G)",
        stateName: "运行状态",
        databaseCreatedTime: "创建时间",
        version:"数据库版本",
        nodeNumber:"节点数量",
        endpoint:"终端节点",
        maintenance: "维护",
        region: "区域",
        iops: "IOPS",
      },
      ElasticBlockStorage: {
        //弹性块存储
        title: "弹性块存储",
        accountName: "账户名称",
        accountID: "账户ID",
        cloudStorageName: "云盘名称",
        searchByCloudStorageName: "请输入云盘名称",
        cloudStorageID: "云盘id",
        cloudStorageCapacity: "盘大小",
        cloudStorageCategory: "盘类型",
        attachedStatus: "关联状态",
        attachedInstanceID: "关联实例ID"
      },
      ElasticIP: {
        //弹性公网IP
        title: "弹性公网IP",
        accountName: "账户名称",
        accountID: "账户ID",
        ElasticIP: "弹性IP",
        allocatedID: "分配ID",
        privateIP: "私有IP",
        AttachedInstance: "关联实例",
        searchByElasticIP: "请输入弹性公网IP"
      },
      ElasticLoadBalancer: {
        //弹性负载均衡
        title: "弹性负载均衡",
        accountName: "账户名称",
        accountID: "账户ID",
        ELBName: "负载均衡名称",
        DNSName: "DNS名称",
        loadbalancerType:"负载均衡类型",
        instanceID: "实例ID",
        region: "地区",
        stateName: "运行状态"
      },
      Redis:{
        //Redis
        title:"Redis",
        instanceId:"实例ID",
        instanceName:"实例名称",
        connectionDomain:"内网连接地址",
        instanceStatus:"实例状态",
        instanceClass:"实例类型",
        engineVersion:"引擎版本",
        architectureType:"架构类型"
      },
      Vpc:{
        title:"虚拟网络",
        name:"VPC名称",
        id:"VPC ID",
        Cidr:"VPC CIDR",
        region:"区域",
        defaultVpc:"默认VPC",
        stateName:"运行状态",
      },
      Oss:{
        title:"存储桶",
        name:"OSS名称",
        creationDateString:"创建时间",
        displayName:"创建人",
        extranetEndpoint:"外网域名",
        intranetEndpoint:"内网域名",
        displayId:"OSS权限",
        access:"读写权限",
        defaultEncryption:"加密",
      },
      NatGateway:{
        title:"NAT网关",
        natGatewayId:"NAT网关ID",
        state:"状态",
        publicIp:"公有IP",
        privateIp:"私有IP",
        vpcId:"VPC",
        createTime:"创建时间",
        name:"网关名称"
      },
      Ack: {
        ackTitle: "Ack",
        accountID: "账户ID",
        accountName: "账户名称",
        region: "区域",
        accountType:"账号类型",
        clusterId:"集群ID",
        clusterName:"集群名称",
        clusterType:"集群类型",
        profile:"集群标识",
        clusterSpec:"托管版集群类型",
        vpcId:"集群专有网络ID",
        size:"集群当前节点数量",
        state:"集群运行状态",
        created:"集群创建时间",
        updated:"集群更新时间"
      },
      AutoScaling:{
        title:"弹性伸缩",
        accountType:"账号类型",
        scalingGroupId:"弹性伸缩组id",
        scalingGroupName:"弹性伸缩组name",
        groupType:"实例类型",
        totalInstanceCount:"所有ECS实例的数量",
        lifecycleState:"状态信息",
        minSize:"ECS实例台数的最小值",
        maxSize:"ECS实例台数的最大值",
        groupModificationTime:"修改时间",
        isActive:"当前数据行是否有效",
      },
      Sls:{
        title:"sls",
        accountTypeName:"账户类型",
        logstoreName:"日志库名称",
        projectName:"项目名称",
      },
      ClickHouse:{
        title:"ClickHouse",
        accountID: "账户ID",
        accountName: "账户名称",
        region: "区域",
        accountType:"账号类型",
        filterByClusterId: "请输入集群ID",
        clusterId:"集群ID",
        nodeCount:"节点数量",
        storageType:"存储类型",
        nodeStorage:"存储空间(GB)",
        nodeClass:"集群规格",
        clusterStatus:"集群状态",
        controlVersion:"版本号",
        createTime:"创建时间"
      },
      Waf:{
        title:"Web应用防火墙",
        accountID: "账户ID",
        accountName: "账户名称",
        region: "区域",
        accountType:"账号类型",
        instanceId:"实例ID",
        statusName:"是否过期",
        versionName:"版本"
      },
      Cen:{
        //Cen
        title:"Cen",
        cenId:"实例ID",
        name:"实例名称",
        description:"描述",
        status:"实例状态",
        ipv6Level:"开启IPv6",
        protectionLevel:"网段重叠级别",
        resourceGroupId:"资源组ID",
        creationTime:"创建时间",
      },
      Kafka:{
        title:"消息队列Kafka",
        accountIdString:"账号ID",
        accountName:"账号Name",
        region: "区域",
        instanceId:"实例ID",
        name:"实例name",
        serviceStatusStr:"实例状态",
        vpcId:"VPC ID",
        specType:"实例规格",
        deployTypeStr:"部署类型",
        diskTypeStr:"磁盘类型",
        diskSize:"磁盘容量",
        createTimeStr:"创建时间"
      },
      ReservedInstances:{
        title:"ECS预留实例券",
        reservedInstanceId: "预留实例劵ID",
        name : "名称",
        platform : "操作系统",
        instanceType : "实例规格",
        status : "状态",
        creationTime : "创建时间",
        expiredTime : "到期时间",
        instanceAmount : "实例数量"
      }
    },
    GCP:{
      computeInstance: {
        //计算实例
        Project:"项目",
        Owner:"拥有者",
      },
      ElasticBlockStorage: {
        //弹性快存储
        awsZone:"可用区",
        region:"区域",
        encrypted:"是否加密",
        accountName:"账户名称",
        accountIdString:"账户id",
        name:"磁盘名称",
        volumeAwsId:"磁盘id",
        capacity:"存储",
        type:"磁盘类型",
        stateName:"状态",
      },
      RelationalDataBaseResource:{
        //数据库
        name:"数据库名称",
        endpoint:"连接名称",
        type:"类型",
        project:"项目",
        backupPolice:"备份策略",
        filterByInstanceName:"请输入数据库名称",
        type:"类型"
      },
      ElasticLoadBalancer:{
       //负载均衡
       region:"区域",
       accountTypeName:"账户类型",
       stateName:"状态"
      },
      CloudStorageGcp:{
        //CloudStorage
        title:"CloudStorage",
        accountType:"账户类型",
        location:"资源地址",
        projectId:"资源所属项目",
        name:"资源名称",
        metaGeneration:"bucket元数据",
        storageClass:"存储类型",
        timeCreated:"创建时间",
        isActive:"是否有效"
      },
      Redis:{
        projectId:"projectId",
        instanceName:"实例名称",
        cacheClusterId:"节点名称",
        version: '版本号',
        cache:'内存大小',
        timeCreated:'创建时间',
        state:"状态",
      },
      BigQuery:{
        title:"BigQuery",
        datasetName:"数据集名称",
        datasetId:"数据集ID",
        projectId:"项目id",
        datasetCreatedTime:"创建时间",
        filterByDatasetId:"请输入数据集ID",
      },
      Kubernetes:{
        title: "GKE",
        name: "集群名称",
        initialClusterVersion: "集群初始版本",
        currentMasterVersion: "当前集群主节点版本",
        currentNodeVersion: "当前节点版本",
        currentNodeCount: "当前节点数量",
        network: "网络名称",
        subnetWork: "子网名称",
        status: "集群状态",
        nodeName:"节点名称",
        nodeLocations:"节点可用区",
        nodeMachineType:"节点的机器类型",
        nodeDiskSize:"磁盘大小",
        nodeImageType:"镜像类型",
        nodeDiskType:"磁盘类型",
        nodeInitialNodeCount:"初始节点数量",
        nodeVersion:"版本",
        nodeStatus:"节点状态",
      },
      FileStore:{
        title: "文件存储",
        filterByGFilestoreName: "请输入文件存储名称",
        accountName:"账户名称",
        accountIdString:"账户ID",
        region:"区域",
        name:"文件存储名称",
        description:"描述",
        state:"运行状态",
        capacity:"容量",
        tier:"实例服务层",
        projectId:"项目ID",
        filestoreCreatetime:"创建时间"
      },
      loggingstored:{
        title:"日志存储",
        accountName:"账户名称",
        accountID:"账户ID",
        location:"区域",
        projectId:"项目ID",
        name:"名称",
        description:"说明",
        retentionDays:"保留期限",
        locked:"状态",
        createTime:"创建时间",
      },
      loggingroute:{
        title:"日志路由",
        accountName:"账户名称",
        accountID:"账户ID",
        location:"区域",
        projectId:"项目ID",
        name:"名称",
        description:"说明",
        type:"类型",
        destination:"目标位置",
        createTime:"创建时间",
      },
      common:{
        location: "区域",
        projectId: "项目ID"
      }
    },
    // 华为云
    HWC: {
      ECS: {
        title: "云服务器",
        accountID: "账户ID",
        accountName: "账户名称",
        region: "区域",
        instanceName: "实例名称",
        instanceID: "实例ID",
        instanceType: "实例类型",
        state: "运行状态",
        diskStorage: "储存大小（GB）"
      },
      RDS: {
        title: "云数据库",
        accountID: "账户ID",
        accountName: "账户名称",
        region: "区域",
        instanceName: "实例名称",
        instanceID: "实例ID",
        engineVersion: "引擎版本",
        state: "运行状态",
        instanceType: "实例类型"
      },
      EVS: {
        title: "云磁盘",
        diskName: "磁盘名称",
        diskID: "磁盘ID",
        diskType: "磁盘类型",
        state: "状态",
        diskStorage: "磁盘大小（GB）",
        encryption: "加密"
      },
      OBS: {
        title: "对象存储",
        bucketName: "桶名称",
        storageType: "存储类别",
        bucketStorage: "桶容量",
        objectCount: "对象数量",
        createTime: "创建时间"
      }
    },
    // 资源配置管理通用项
    common:{
      update:'更新',
      multiLineExport:'多行导出',
      filterByAccountName:'请输入账户名称',
      filterByLoadName:'请输入负载均衡名称',
      filterByResourceName: '请输入资源名称',
      QuerybyInstanceID:'请输入实例ID',
      QuerybyInstanceName:'请输入实例名称',
      QuerybyPublicIP:'请输入公有IP',
      QueryByTgwId:"请输入中转网关ID",
      QueryByBackupVaultName:"请输入备份保管库名称",
      QueryByBackupPlanName:"请输入备份计划名称",
      PleaseSelectCompany:'请选择公司',
      SearchbyEngine:'请输入引擎',
      QuerybyInstanceType:'请输入实例类型',
      FilterbyOperatingStatus:'请输入运行状态',
      QuerybyBucketName:'请输入桶名称',
      QuerybyClusterName:'请输入集群名称',
      PleaseSelectAccount:'请选择账号',
      PleaseSelectRegion:'请选择区域',
      PleaseEnterAccountID:'请输入账户ID',
      PleaseChoosePaymentMethod:'请选择付款方式',
      PleaseSelectStatus:'请选择状态',
      PleaseSelectExpirationTime:'请选择到期时间',
      PleaseEnterEngine:'请输入引擎',
      PleaseSelectEngine:'请选择引擎',
      PleaseSelectProductType:'请选择产品类型',
      QuerybySubnetID:'请输入子网ID',
      QuerybySecurityGroupID:'请输入安全组ID',
      PleaseSelectResourceType:'请选择资源类型',
      PleaseSelectEventType:'请选择事件类型',
      PleaseSelectTimeRange:'请选择时间范围',
      DomainName:'域名称',
      QuerybyStorageAccountName:'请输入存储账户名',
      QuerybyResourceGroup:'请输入资源组',
      PleaseSelectTagValue:'请输入标签值'
    }
  },
  //审批任务
  ApprovalTask: {
    title: "审批任务",
    approvalFlowName: "审批流名称",
    companyName: "公司名称",
    submitter: "提交人",
    category: "类型",
    status: "状态",
    launchTime: "创建时间",
    processing: '处理中',
    passed: '已通过',
    rejected: '已驳回',
    expired: '已失效',
    selectByCompany: '请选择公司',
    selectByType: '请输入类型',
    selectAll: '全部',
    processInformation: '流程信息',
    approvalStatus: '审批状态',
    startTime: '开始时间',
    endTime: '结束时间',
    view: '查看',
    dealwith: '处理',
    reservedInstancePurchase: '预留实例购买',
    associatedCaseID: '关联案例ID',
    contentOfTheParentNode: '上级节点内容',
    matchType: '匹配类型',
    purchaseList: '购买清单',
    reservedInstancePurchaseList: '预留实例购买清单',
    tip: '您目前自定义购买的RI数量是少于系统建议的到期RI购买数量的，在您保存并审批该自定义购买后，系统在实际购买前将自动不会对该批RI中未购买的部分进行告警，除非在实际购买前您需要购买的RI数量发生了变化。如果在实际购买前您需要购买的RI数量发生了变化的情况，系统将自动产生一个新的审批任务，并同时删除当前已经被审批完成的任务。',
    rawData: '原始数据',
    standardizedQuantity: '标准化数量',
    accountName: '账户名称',
    accountId: '账号ID',
    region: '区域',
    instanceCount: '数量',
    normalizationFactor: '标准化数量',
    actualPurchasedQuantity: '建议购买数量',
    instanceType: '预留实例类型',
    price: 'RI价格',
    productDescription: '产品描述',
    instanceTenancy: '租赁类型',
    offeringType: '付费方式',
    offeringClass: '提供的类别',
    endDate: '到期时间',
    duration: '时间期限'
  },
  AlertConfigManagement: {
    //报警配置管理
    CostomizedAlarm: {
      //自定义报警配置
      isAccountGroup: "是否为账户组",
      AccountGroupName: "账户组名称",
      status: "状态"
    }
  },
  BSH: {
    resourceGroup: "资源组",
    resourceGroupName: "资源组名称",
    account: "账户",
    region: "区域",
    tagKey: "标签关键字",
    tagValue: "标签值",
    searchTagKey: "请输入标签关键字",
    searchTagValue: "请输入标签值",
    searchResourceGroupName: "请输入资源组名称",
    add: "新增",
    basicInfo: "基本信息",
    companyName: "公司名",
    resourceAllocation: "资源分配",
    uniqueIdentifierOfResource: "资源唯一标识符",
    searchUniqueIdentifierOfResource: "请输入资源唯一标识符",
    alarmConfiguration: "告警配置",
    pleaseSelectNotificationObject: "请选择通知对象",
    pleaseSelectAlarmType: "请选择报警方式",
    pleaseSelectAlarmDelay: "请选择延迟告警",
    monitoringState: "监控状态",
    monitorIndexName: "指标名称"
  },
  MCM: {
    //MaintenanceConfigManagement
    //运维配置管理
    dutyManagement: {
      //值班管理
      title: "值班管理",
      editDuty: "编辑值班",
      name: "姓名",
      pleaseSelectName: "请选择姓名",
      dutyType: "值班类型",
      pleaseSelectDutyType: "请选择值班类型",
      dutyTime: "值班时间",
      pleaseSelectDutyTime: "请选择值班时间",
      comment: "备注",
      operation: "操作",
      addDuty: "添加值班",
      priority: "排班优先级",
      pleaseSelectPriority: "请选择排班优先级",
      dayShift: "白班",
      nightShift: "夜班"

    },
    extraContributionManagement: {
      //额外贡献管理
      title: "额外贡献管理",
      editExtraContribution: "编辑额外贡献",
      name: "姓名",
      attachment: "附件",
      attachmentList: "附件列表",
      PleaseSelectName: "请选择姓名",
      extraContributionTime: "额外贡献时间",
      additionalContributionStatistics: "额外贡献统计",
      pleaseEnterExtraContributionTime: "请输入额外贡献时间",
      extraContributionDate: "额外贡献年月",
      pleaseSelectExtraContributionDate: "请选择额外贡献年月",
      description: "描述",
      pleaseEnterDescription: "请输入描述",
      EnterMaximumOfCharacters: "最多输入10000个字符",
      operation: "操作",
      addExtraContribution: "添加额外贡献",
      addExtraContributionAttachment: "添加额外贡献附件",
      filename: "文件名",
      fileType: "文件类型",
      saveAddress: "保存地址",
      PleaseSelectTheFileToUpload: "请选择要上传的文件"

    },
    automaticalMaintenanceReport: {
      //自动化运维报告
      title: "自动化运维报告",
      companyName: "公司名称",
      pleaseSelectCompany: "请选择公司",
      account: "账户",
      pleaseSelectAccount: "请选择账号",
      filterByAccount: "请输入账号",
      month: "月份",
      pleaseSelectMonth: "请选择月份",
      region: "区域",
      pleaseSelectRegion: "请选择区域",
      config: "配置",
      operation: "操作",
      add: "添加",
      edit: "编辑",
      preview: "预览",
      reportConfig: "报告配置"

    }
  },
  approvalFlowConfigManagement: {
    //审批流配置管理
    Node: {
      //节点
      title: "节点",
      addNode: "添加节点",
      nodeName: "节点名称",
      nodeCompany: "节点所属公司",
      user: "用户",
      role: "角色",
      operation: "操作",
      confirmAddNode: "确认添加节点",
      type: "类型",
      nodeType: '节点类型',
      companyName: '公司名称',
      queryByNodeName: '请输入节点名称',
      nodeNameNotEmpty: '节点名称不能为空',
      nodeNameValidateMsg: '节点名称为4-20个字符',
      pleaseSelectNodeType: '请选择类型',
      pleaseSelectUser: '请选择用户',
      pleaseSelectRole: '请选择角色',
      pleaseSelectCompany: '请选择公司',
      editNode: '编辑节点',
      nodeContent: '节点内容'
    },
    approvalFlow: {
      //审批流
      title: "审批流",
      addApprovalFlow: "添加审批流",
      approvalFlowName: "审批流名称",
      approvalFlowCompany: "审批流所属公司",
      companyName: "公司名称",
      pleaseSelectCompany: "请选择公司",
      type: "类型",
      status: "状态",
      operation: "操作",
      delete: "删除",
      editButton: '编辑',
      queryByFlowName: '请输入审批流名称',
      editApprovalFlow: '编辑审批流',
      flowNameNotEmpty: '审批流名称不能为空',
      flowNameValidateMsg: '审批流名称为4-20个字符',
      pleaseSelectType: '请选择类型',
      connectionSucceeded: '连接成功',
      nodeNotConnectingItself: '节点不支持连接自己',
      relationAlreadyExist: '该关系已存在,不允许重复创建',
      nodeNotSupportLookBack: '不支持两个节点之间连线回环'
    }
  },

  LabelConfig: {
    LabelSynchronization: {
      title: "标签同步",
      company: "公司",
      account: "账号",
      resourceType: "资源类型",
      attachment: "附件",
      Keys: "密钥文件",
      attention: "注意：将根据文件中的资源标签覆盖原有标签!",
      updateTag: "更新标签",
      synchronizingTag: "同步标签",
    }
  },
  smartMonitor: {
    //智能监控
    dashboard: {
      //仪表盘
      title: "仪表盘",
      applicationHealthStatus: "应用健康状态",
      instanceResourceName: "资源名称(实例)",
      databaseResourceName: "资源名称(数据库)",
      resourceList: "资源列表",
      accountID: "账户ID",
      accountName: "账户名称",
      instanceName: "实例名称",
      instanceID: "实例ID",
      weight: "权重",
      rating: "评分",
      operation: "操作",
      database: "数据库",
      databaseName: "数据库名称",
      databaseID: "数据库ID",
      resourceIndexConfig: "资源指标配置",
      resourceType: "资源类型",
      resourceName: "资源名称",
      resourceID: "资源ID",
      index: "指标",
      fittingDegreeEstimation: "拟合度参考值",
      MonitorIndexAlert: "监控指标告警",
      currentFittingDegree: "当前拟合度",
      currentIndexRating: "当前指标评分",
      caseID: "案例ID",
      detail: "详情",
      smartMonitorTitle: "智能监控数据库"
    },
    applicationSystem: {
      //应用系统
      title: "应用系统",
      addApplication: "添加应用",
      name: "名称",
      config: "配置",
      operation: "操作",
      applicationConfig: "应用配置",
      addInstance: "添加实例",
      addDatabase: "添加数据库",
      instanceName: "名称",
      account: "账户",
      instanceID: "实例ID",
      region: "区域",
      privateIP: "私有IP",
      status: "状态"
    },
    applicationSystemAlert: {
      //应用系统告警
      title: "应用系统告警",
      applicationName: "应用名称",
      resourceType: "资源类型",
      resourceName: "资源名称",
      resourceID: "资源ID",
      caseID: "案例ID",
      Index: "指标",
      launchTime: "创建时间",
      setIgnorance: "是否忽略",
      operation: "操作",
      detail: "详情",
      CPUUtilization: "CPU使用率",
      CPUUtilizationPrediction: "CPU使用率预测",
      cache: "内存",
      cacheUtilization: "内存使用率",
      cacheUtilizationPrediction: "内存使用率预测",
      networkInput: "网络流入(字节)",
      networkInputPrediction: "网络流入预测",
      networkOutput: "网络流出(字节)",
      networkOutputPrediction: "网络流出预测",
      index: "指标",
      indexRating: "指标评分",
      indexFittingDegree: "指标拟合度",
      predictionValue: "预测值",
      currentValue: "当前值",
      monitorTitle: "智能监控实例"
    }
  },
  tag: {
    tag: '标签',
    labelProcessing:'标签处理 (Under Construction)',
    setUpTagMapping: "设置标签映射",
    searchTagMapping: "查询标签映射",
    search: "查询",
    standardTag: '标准标签',
    resourceTag: '资源标签',
    tagMapping: '标签映射',
    pleaseInputTag: '请输入标签',
    addTag: '添加标签',
    tagName: '标签名称',
    thisTag: '该标签吗',
    thisMappingTag: '该标签映射吗',
    editTag: '编辑标签',
    pleaseSelectAwsResourceType: '请选择AWS资源类型',
    resourceId: '资源ID',
    resourceName: '资源名称',
    pleaseSelectStandardTag: '请选择标准标签',
    mappingTag: '映射标签',
    addMappingTag: '添加标签映射',
    update:'更新'
  },
  resourceLifecycle: {
    purchaseAllUpfrontOneYearPrice: "购买RI价格（一年|All Upfront）",
    purchaseNoUpfrontOneYearPrice: "购买RI价格 （No Upfront）",
    //Common
    queryByPurpose: "请输入用途",
    queryByResourceName: "请输入资源名称",
    filterByResourceType: "请输入资源类型",
    attachment: "附件",
    clickOrDragFileHere: "单击或拖动文件到此处上传",
    submit: "提交",
    process: "流程",
    virtualMachine: "虚拟机",
    virtualNetwork: "虚拟网络",
    objectStorage: "对象存储",
    database: "托管数据库",
    elasticIP: "弹性IP",
    azureMySQLServer: "Azure MySQL 服务器",
    azureMariaDBServer: "Azure MariaDB 服务器",
    azureRedisServer: "Azure Redis 服务器",
    select: "选择",
    view: "查看",
    fileName: "文件名",
    fileType: "文件类型",
    change: "变更",
    renew: "续约",
    recycle: "回收",
    use: "用途",
    platform: "平台",
    cloudPlatform: "云平台",
    region: "区域",
    resourceName: "资源名称",
    resourceType: "资源类型",
    resourceState: "资源状态",
    resourceConfig: "资源配置",
    environment: "环境",
    term: "期限（月）",
    startDate: "开始日期",
    endDate: "结束日期",
    estimatedCost: "预估花费（元）",
    download: "下载",
    basicInformation: "基本信息",
    accountId: "账号",
    resourceGroup: "资源组",
    pleaseEnter: "请输入",
    pleaseSelect: "请选择",
    periodOfUse: "使用期限",
    months: "个月",
    clickordragfilestouploadhere: "单击或拖动文件到此处上传",
    remark: "备注",
    application: "申请",
    produce: "生产",
    development: "测试",
    name: "名称",
    databaseName: "数据库名称",
    databaseEngine: "数据库引擎",
    databaseVersion: "数据库版本",
    databaseEngineVersion: "数据库引擎版本",
    databaseInstanceType: "数据库实例类型",

    //资源服务目录
    resourceServiceDirectory: "资源服务目录",
    addResource: "添加资源",
    //资源申请
    pleasechoosecloudplatform: "请选择云平台",
    pleaseselectanaccount: "请选择账号",
    pleaseselectaregion: "请选择区域",
    useCannotbeempty: "用途不能为空",
    theexpirationdatecannotbeempty: "使用期限不能为空",
    pleaseselectresourcetype: "请选择资源类型",
    pleaseselectresourcegroup: "请选择资源组",
    pleaseselectresourceenvironment: "请选择环境",
    pleaseselectresourceprocess: "请选择流程",
    pleaseenterabackup: "请输入备份",
    successfulApplication: "申请成功",
    resourceApplication: "资源申请",
    namecannotbeempty: "名称不能为空",
    basicinformationElasticIP: "基本信息 (弹性IP)",
    multiAZDeployment: "多可用区部署",
    allocatedStorageSpace: "分配存储空间",
    storageType: "存储类型",
    presetIOPS: "预置IOPS",
    masterUsername: "主用户名",
    masterPassword: "主密码",
    databaseParameterGroup: "数据库参数组",
    optionGroup: "选项组",
    iamDatabaseAuthentication: "IAM数据库身份验证",
    publicAvailability: "公开可用性",
    availabilityZone: "可用区",
    subnetGroup:"子网组",
    vpcSecurityGroup:"VPC 安全组",
    existingSecurityGroup:"现有安全组",
    selectAll:"全选",
    copyTagsToSnapshot:"是否复制标签给快照",
    enableDeleteProtection:"是否开启删除保护",
    universalSSD:"universalSSD",
    presetIOPSSSD:"预置IOPS(SSD)",
    createcopiesindifferentregions:"在不同区域创建副本",
    no:"否",
    basicinformationhosteddatabase:"基本信息（托管数据库）",
    yes:"是",
    enableIAMdatabaseauthentication:"启用IAM数据库身份验证",
    disable:"禁用",
    createanewVPCsecuritygroup:"创建新的VPC安全组",
    selectanexistingVPCsecuritygroup:"选择现有VPC安全组",
    databasenamecannotbeempty:"数据库名称不能为空",
    pleaseselectadatabaseengine:"请选择数据库引擎",
    pleaseselectthedatabaseengineversion:"请选择数据库引擎版本",
    pleaseselectthedatabaseversion:"请选择数据库版本",
    pleaseselectthedatabaseinstancetype:"请选择数据库实例类型",
    pleaseselectmultizonedeployment:"请选择多可用区部署",
    pleaseselectstoragetype:"请选择存储类型",
    pleaseentertheallocatedstoragespace:"请输入分配的存储空间",
    pleaseenterthepresetIOPS:"请输入预置IOPS",
    themainusernamecannotbeempty:"主用户名不能为空",
    masterpasswordcannotbeempty:"主密码不能为空",
    pleaseentertheport:"请输入端口",
    account:"账号:",
    area:"区域:",
    uses:"用途:",
    periodofuse:"使用期限:",
    flow:"流程:",
    resourceConfiguration:"资源配置",
    dBInstanceClass:"数据库实例类:",
    allottedstorage:"分配的存储空间:",
    ports:"端口:",
    databaseParameterGroups:"数据库参数组:",
    optionGroups:"选项组:",
    iAMDatabaseAuthentication:"IAM数据库身份验证:",
    vPCSecurityGroup:"VPC 安全组:",
    existingSecurityGroups:"现有安全组:",
    copylabelforsnapshot:"是否复制标签给快照:",
    enabledeleteprotection:"是否启用删除保护:",
    exhibits:"附件",
    remarkation:"备注:",
    estimatedcost:"预估费用:",
    filenames:"文件名",
    bucketName:"存储桶名称",
    pleaseenter:"请输入",
    copysettingsfromanexistingbucket:"从现有存储桶复制设置",
    basicinformationobjectstorage:"基本信息 (对象存储)",
    bucketname:"存储桶名称:",
    estimatedcosts:"预估费用",
    enableTerminationProtection:"启用终止保护",
    numberofinstances:"实例数量",
    keypair:"密钥对",
    surveillance:"监控",
    webs:"网络",
    securityGroup:"安全组",
    automaticdistributionofpublicIP:"自动分配公网IP",
    disks:"磁盘",
    calculationSpecifications:"计算规格",
    cloudPlatformSpecifications:"云平台规格",
    operatingsystem:"操作系统",
    tags:"标签",
    pleaseselectEnableTerminationProtection:"请选择启用终止保护",
    pleaseenterthenumberofinstances:"请输入实例数量",
    pleaseselectakeypair:"请选择密钥对",
    pleaseselectMonitoring:"请选择监控",
    pleaseselectCalculationSpecification:"请选择计算规格",
    pleaseselecttheoperatingsystem:"请选择操作系统",
    pleaseselectamirror:"请选择镜像",
    pleaseselectsubnet:"请选择子网",
    pleaseselectnetwork:"请选择网络",
    pleaseselectAutoAssignPublicIP:"请选择自动分配公网IP",
    pleaseselectasecuritygroup:"请选择安全组",
    selects:"选择",
    models:"机型",
    numberofCPUcores:"CPU数量(核)",
    memoryGB:"内存(GB)",
    volumeType:"卷类型",
    availabilityZones:"可用区域",
    sizeGiB:"大小（GiB）",
    whethertoencrypt:"是否加密",
    operations:"操作",
    basicInformationVirtualMachine:"基本信息 (虚拟机)",
    keyPair:"密钥对:",
    monitoring:"监控:",
    network:"网络:",
    disk:"磁盘:",
    numberofCPUs:"CPU数量:",
    memory:"内存:",
    rAM:"内存",
    vPCName:"VPC名称",
    vPCIPv4CIDRblock:"VPC IPV4 CIDR块",
    iPv6CIDRblock:"IPV6 CIDR块",
    hardwareRental:"硬件租赁",
    subnetNameLabel:"子网名称标签",
    subnetIPv4CIDRblock:"子网 IPV4 CIDR块",
    vPCIPV4CIDRblockcannotbeempty:"VPC IPV4 CIDR块不能为空",
    subnetIPv4CIDRblockcannotbeempty:"子网 IPV4 CIDR块不能为空",
    pleaseselectIPv6CIDRblock:"请选择IPV6 CIDR块",
    pleaseselectHardwareRental:"请选择硬件租赁",
    subnetnametagcannotbeempty:"子网名称标签不能为空",
    basicInformationVirtualNetwork:"基本信息 (虚拟网络)",
    subnetNameTag:"子网名称标签:",
    assign:"分配",
    pleaseselectSKU:"请选择SKU",
    pleaseselectAssignment:"请选择分配",
    basicInformationElasticIP:"基本信息(弹性IP)",
    assignment:"分配:",
    databaseTypes:"数据库类型",
    serverName:"服务器名称",
    versions:"版本",
    serverTypes:"服务器类型",
    storing:"存储",
    storageAutomatedGrowth:"存储自动增长",
    backuphold:"备份保持期",
    backupredundancy:"备份冗余",
    username:"用户名",
    passwords:"密码",
    pricingLayer:"定价层",
    whethertoenableunencryptedSSL:"是否启用非加密的SSL",
    enabling:"启用",
    donotenable:"不启用",
    disabling:"禁用",
    localredundancy:"本地冗余",
    districtredundancy:"地区冗余",
    pleaseselecttheversion:"请选择版本",
    pleaseselecttheservertype:"请选择服务器类型",
    pleaseselectthedatabasetype:"请选择数据库类型",
    usernamecannotbeempty:"用户名不能为空",
    pleaseenterapassword:"请输入密码",
    dNSnamecannotbeempty:"DNS名称不能为空",
    pleaseselectPricingLevel:"请选择定价层",
    pleaseselectwhethertoenablenonsslRedisserverport:"请选择是否启用是否启用非ssl Redis服务器端口",
    pleaseentervCore:"请输入vCore",
    pleaseenterstorage:"请输入存储",
    pleaseenterthebackuphold:"请输入备份保持期",
    pleaseselectthestorageforautogrowth:"请选择存储自动增长",
    pleaseselectBackupRedundancy:"请选择备份冗余",
    basicinformationmanageddatabase:"基本信息 (托管数据库)",
    databaseType:"数据库类型:",
    version:"版本:",
    serverType:"服务器类型:",
    storage:"存储:",
    password:"密码:",
    dNSName:"DNS名称:",
    pricingTier:"定价层:",
    whethertoenablenonencryptedSSL:"是否启用非加密的SSL:",
    publicaccesslevel:"公共访问级别",
    storageAccounts:"存储账户",
    pleaseselectPublicAccessLevel:"请选择公共访问级别",
    pleaseselectastorageaccount:"请选择存储账户",
    publicAccessLevel:"公共访问级别:",
    storageAccount:"存储账户:",
    oSDiskType:"OS磁盘类型",
    pleaseselectOSDiskType:"请选择OS磁盘类型",
    addressrangecannotbeempty:"地址范围不能为空",
    subnetName:"子网名称",
    addressRange:"地址范围:",
    noIPv6CIDRblock:"无IPv6 CIDR块",
    ipv6CIDRblockprovidedbyAmazon:"Amazon 提供的IPv6 CIDR块",

    //资源变更
    queryResources:"查询资源",
    querybyPurpose:"请输入用途",
    querybyResourceName:"请输入资源名称",
    filterbyresourcetype:"请输入资源类型",
    clickordragthefiletouploadhere:"单击或拖动文件到此处上传",
    pleaseselecttheflow:"请选择流程",
    platforms:"平台",
    zones:"区域",
    surroundings:"环境",
    periodmonths:"期限（月）",
    startdate:"开始日期",
    estimatedcostyuan:"预估花费（元）",
    resourceChange:"资源变更",
    resourcechangeinformation:"资源变更信息",
    subnet:"子网:",
    add:"添加",
    delete:"删除",
    keyupto128characters:"键 （最多128个字符）",
    valueupto256characters:"值 （最多256个字符）",
    addTag:"添加标签",
    atleastonesubdimensionisrequired:"至少需要一个子维度",
    filterbyResourceType:"请选择资源类型",
    renewationPeriod:"续约期限",
    vMs:"虚拟机",
    objectstorage:"对象存储",
    manageddatabase:"托管数据库",
    resourceRenew:"资源续约",
    resourceRenewationInformation:"资源续约信息",
    renewerPeriod:"续约期限:",
    base:"基础",
    generalPurpose:"常规用途",
    memoryOptimization:"内存优化",


    //资源回收
    resourceRecycle:"资源回收",
    searchResource:"查询资源",
    resourceAllocation:"资源配置",
    resourceReturnOrRecycleReason:"资源返还/回收原因",
    blobonlyanonymousreadaccessBlob:"Blob(仅匿名读取访问Blob)",
    containeranonymousreadaccessblob:"容器（匿名读取访问Blob）",
    dedicatednoanonymousaccess:"专用（无匿名访问）",
    usingCIDRnotation:"虚拟网络的地址空间，采用 CIDR 表示法(例如 192.168.1.0/24)指定为一个或多个地址前缀。",
    addresourcepricecoefficient:"添加资源价格系数",

    //资源服务运营报告
    resourceRecycleInfo:"资源回收信息",
    resourcespendmonthstatistics:"资源花费月统计图",
    listofresources:"资源列表",
    resourcesspentthismonth:"本月资源花费",
    fees:"费用:",
    numberofresources:"资源数量",
    totalresourcecost$:"资源总花费(￥)",
    incorporation:"公司",
    coefficients:"系数",
    picturing:"描述",
    lastPrice:"最后价格",
    pleaseselectacompany:"请选择公司",
    pleaseselectthecloudplatform:"请选择云平台",
    pleaseselecttheresourcetype:"请选择资源类型",
    pleaseenterthecoefficient:"请输入系数",
    pleaseenteradescription:"请输入描述",
    filterbycloudplatform:"请输入云平台",
    companyName:"公司名称",
    resourcepricefactorconfiguration:"资源价格系数配置",
    resourceServiceOperationsReport:"资源服务运营报告",
    pleaseselectDatabaseParameterGroup:"请选择数据库参数组",
    pleaseselectanoptiongroup:"请选择选项组",
    pleaseselectIAMDatabaseAuthentication:"请选择IAM数据库身份验证",
    pleaseselectvpc:"请选择vpc",
    pleaseselectSubnetGroup:"请选择子网组",
    pleaseselectPublicAvailability:"请选择公开可用性",
    pleaseselectanAvailabilityZone:"请选择可用区",
    pleaseselectVPCSecurityGroup:"请选择VPC 安全组",
    pleaseselectanexistingsecuritygroup:"请选择现有安全组",
    bucketnamecannotbeempty:"存储桶名称不能为空",
    pleasechoosetocopysettingsfromanexistingbucket:"请选择从现有存储桶复制设置",
    //Input Validation
    inputValidation: {
      requiredProcess: "请选择流程",
      requiredResourceReturnOrRecycleReason: "请填写资源返还/回收原因",
    },

    //UI Response
    response: {
      uploadSuccess: "上传成功",
      uploadFail: "上传失败",
      deleteSuccess: "删除成功",
      recycleSuccess: "回收成功",
      downloadSuccess: "下载成功",
      renewSuccess: "续约成功",
      addSuccess: "添加成功",
      addFail: "添加失败",
      editSuccess: "编辑成功",
      editFail: "编辑失败",
    }

  },
  OriginalBillEntry:{
    BillingBucketConfiguration:'账单存储桶配置',
    uploadbill:'上传账单',
    company:'公司',
    account:'账户',
    PaymentAccount:'付款账号',
    select:'查询',
    config:'配置',
    accountName:'账户名称',
    accountNumberName:'账号名称',
    accountID:'账号id',
    bucketName:'桶名称',
    SynchronizeRecords:'同步记录',
    del:'删除',
    cancel:'取消',
    confirm:'确认',
    region:'区域',
    month:'月份',
    upload:'上传',
    fileName:'文件名称',
    startTime:'开始时间',
    endTime:'结束时间',
    syncStatus:'同步状态',
    syncMsg:'同步信息',
    syncTime:'同步时间',
    syncType: '同步类型',
    syncRecord:'同步记录',
    uploadMsg:'单击或拖动文件到此处上传',
    uploadAttachment: "上传附件：",
    pleaseEnterPayAccount: "请输入付款账号"
  },
  aiChat: {
    title: '数字运维工程师',
    thinking: '思考中',
    content: '由ETOOLINING提供的AI数字运维工程师，可以帮您查询实例数据，检查资源状态，筛选性能指标，快速定位日志等。',
    questionText: '可以试着问：',
    questionOne: '查询北京区域所有运行中的EC2实例CPU使用率？',
    questionTwo: '当前待处理的P1级案例有哪些？',
    questionThree: '列出AWS中连续3个月CPU利用率低于30%的EC2实例。',
    createNewConversation: '创建新的对话',
    pleaseEnterYourQuestion: '请输入问题',
    historicalConversationRecords: '历史对话记录',
    conversationDetails: '对话详情',
    areYouSureToDeleteThisChatRecord: '是否确认删除该对话？删除后不可恢复。',
    copyText: '复制文字',
    answerAgain: '重新回答',
    like: '点赞',
    cancelLike: '取消点赞',
    dislike: '点踩',
    cancelDislike: '取消点踩',
    thinkText: '分析中...',
    deepThinking: '已深度思考',
    timeSpent: '用时',
    seconds: '秒',
    user: '用户',
    assistant: 'AI助手',
    inputPlaceholder: '在这里输入消息，按 Enter 发送',
    loading: '加载中...',
    noMoreData: '没有更多数据了'
  }


};




// WEBPACK FOOTER //
// ./src/i18n/lang/zh.js